"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74768],{

/***/ 26226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ NavMore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48308);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc((100%-45px) / 2);\n\n  @media ",
        " {\n    width: calc((100%-45px) / 3);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 4);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 6);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 9);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  text-decoration: none;\n  color: ",
        ";\n  cursor: pointer;\n  border-left: 1px solid ",
        ";\n\n  :first-child {\n    border-left: unset;\n  }\n\n  :focus,\n  :active {\n    color: ",
        ";\n    background: ",
        ";\n    :hover {\n      color: ",
        ";\n    }\n  }\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  display: flex;\n  border-top: 1px solid ",
        ";\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  flex-wrap: ",
        ";\n  width: ",
        ";\n\n  & > a {\n    ",
        ";\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      height: auto;\n      opacity: 1;\n      visibility: visible;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 200px;\n  position: absolute;\n  right: 0;\n  height: 0px;\n  opacity: 0;\n  visibility: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ",
        ";\n  border-top: none;\n  padding: 10px 0;\n  transition: all 0.2s ease-in-out;\n  z-index: 5;\n\n  a:nth-child(-n + ",
        ") {\n    display: none;\n  }\n\n  & > a {\n    ",
        ";\n    border-left: unset;\n    text-align: right;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-width: ",
        ";\n  border-color: ",
        ";\n  border-style: solid;\n  border-left: 1px solid ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    display: ",
        ";\n    width: 50px;\n    height: 1px;\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -1px;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 40px;\n\n  & > span {\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var navigationWidthByDevice = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), _style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileS */ .Z.mobileS, _style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileL */ .Z.mobileL, _style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet, _style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].laptop */ .Z.laptop);
var Navigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dimGray */ .Z.dimGray, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var NavBarWebWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6267faaf-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro);
var HorizontalNavigations = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_common__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC).withConfig({
    componentId: "sc-6267faaf-1"
})(_templateObject3(), function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "unset" : "wrap";
}, function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "100%" : "auto";
}, Navigation, function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "100%" : navigationWidthByDevice;
});
var VerticalNavigations = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6267faaf-2"
})(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(props) {
    return props.elementToShow;
}, Navigation, function(param) {
    var isOpen = param.isOpen;
    return isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
});
var NavMoreLogoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6267faaf-3"
})(_templateObject6(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0px 1px" : "0px";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
var Relative = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6267faaf-4"
})(_templateObject7());
var NavMoreWrapper = function(param) {
    var ExpandLogo = param.ExpandLogo, children = param.children, elementToShow = param.elementToShow;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), hideModal = ref[0], setModal = ref[1];
    var navMoreRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var onNavMoreClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (navMoreRef.current.contains(e.target)) {
            return setModal(!hideModal);
        }
        return setModal(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        document.addEventListener("click", onNavMoreClick);
        return function() {
            document.removeEventListener("click", onNavMoreClick);
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Relative, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavMoreLogoWrapper, {
                ref: navMoreRef,
                isOpen: !hideModal,
                onClick: function(e) {
                    return onNavMoreClick(e);
                },
                children: elementToShow !== children.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExpandLogo, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VerticalNavigations, {
                isOpen: !hideModal,
                elementToShow: elementToShow,
                children: children
            })
        ]
    });
};
var NavMore = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6267faaf-5"
})(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary : "";
});
var NavMoreLogo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NavMore, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
        ]
    });
};
var NavBarComponent = function(param) {
    var className = param.className, children = param.children, _expandNavLogo = param.expandNavLogo, expandNavLogo = _expandNavLogo === void 0 ? function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
    } : _expandNavLogo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), moreNavElement = ref[0], setMoreNavElement = ref[1];
    var navHorizontalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ExpandNavLogo = expandNavLogo;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var navigation = navHorizontalRef.current.children;
        var moreNavigation = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(navigation).filter(function(e) {
            return e.offsetTop === 0;
        }).map(function(e) {
            return e.innerText;
        });
        setMoreNavElement(moreNavigation);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NavBarWebWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalNavigations, {
                isNavigationBlock: moreNavElement.length === children.length,
                ref: navHorizontalRef,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavMoreWrapper, {
                ExpandLogo: ExpandNavLogo,
                elementToShow: moreNavElement.length,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    NavMoreLogo: NavMoreLogo,
    NavBarComponent: NavBarComponent
});


/***/ }),

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19546);
/* harmony import */ var _tests_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(376);





function RoomItemAvatar(param) {
    var type = param.type, src = param.src, name = param.name, shortName = param.shortName, isDeactive = param.isDeactive;
    if (type === "ROOM_TYPE_PERSONAL") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
            "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_4__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR */ .IB,
            children: isDeactive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: "/images/avatar.png",
                alt: "User Not Found Avatar"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                alt: name,
                src: (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .transformAvatarUrl */ .rK)(src),
                onError: function(e) {
                    return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
                }
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
        "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_4__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR */ .IB,
        children: src === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .GroupAvatar */ .NS, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                "data-username": name,
                children: shortName
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            alt: name,
            src: src,
            onError: function(e) {
                return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
            }
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RoomItemAvatar);


/***/ }),

/***/ 376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION_COUNT; },
/* harmony export */   "F9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER; },
/* harmony export */   "IB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR; },
/* harmony export */   "Jf": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED; },
/* harmony export */   "QB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION; },
/* harmony export */   "X3": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_ACCEPT; },
/* harmony export */   "XY": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION; },
/* harmony export */   "c2": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW; },
/* harmony export */   "dI": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED; },
/* harmony export */   "dh": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST; },
/* harmony export */   "e3": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_DELETE; },
/* harmony export */   "e9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_CANCEL_BUTTON; },
/* harmony export */   "eO": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_TOOLTIP_CREATE_GROUP; },
/* harmony export */   "h5": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM; },
/* harmony export */   "hK": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_INPUT_SEARCH; },
/* harmony export */   "i4": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_BUTTON; },
/* harmony export */   "iu": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER; },
/* harmony export */   "jL": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CANCEL; },
/* harmony export */   "nJ": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED; },
/* harmony export */   "o2": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED_EMPTY; },
/* harmony export */   "oG": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CONFIRM; },
/* harmony export */   "pD": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_SEARCHED_RESULT; },
/* harmony export */   "q9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED_EMPTY; },
/* harmony export */   "tw": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_EDIT_BUTTON; },
/* harmony export */   "v6": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM; }
/* harmony export */ });
/* unused harmony exports TEST_CASE_MESSAGE_COMPONENTS, QUERY_STRING_TYPE_INVTED */
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " should render successfully")
    };
};
// ListRoom
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM = "chat-page-left-panel-room-list-index";
// RoomList
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED = "chat-page-left-panel-room-list-accepted";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED = "chat-page-left-panel-room-list-invited";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED_EMPTY = "chat-page-left-panel-room-list-accepted-empty";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED_EMPTY = "chat-page-left-panel-room-list-invited-empty";
// RoomItem
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM = "chat-page-left-panel-room-item";
// New Message Searched Result
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_SEARCHED_RESULT = "chat-page-left-panel-new-message-searched-result";
// RoomItemAvatar
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR = "chat-page-left-panel-room-item-avatar";
// MessageRequestCount
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION = "chat-page-left-panel-message-request-section";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION_COUNT = "chat-page-left-panel-message-request-section-count";
// LastMessagePreview
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW = "chat-page-left-panel-last-message-preview";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED = "chat-page-left-panel-last-message-preview-deleted";
// Header
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER = "chat-page-left-panel-header";
// HeaderRequest
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST = "chat-page-left-panel-header-request";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_CANCEL_BUTTON = "chat-page-left-panel-header-request-cancel-button";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_EDIT_BUTTON = "chat-page-left-panel-header-request-edit-button";
// Footer
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER = "chat-page-left-panel-footer";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_DELETE = "chat-page-left-panel-footer-delete";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_ACCEPT = "chat-page-left-panel-footer-accept";
// InputSearch
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_INPUT_SEARCH = "chat-page-left-panel-input-search";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_BUTTON = "chat-page-left-panel-new-message-button";
// ModalConfirmation
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION = "chat-page-left-panel-modal-confirmation";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CANCEL = "chat-page-left-panel-modal-confirmation-cancel-button";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CONFIRM = "chat-page-left-panel-modal-confirmation-confirm-button";
// Tooltip create group
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_TOOLTIP_CREATE_GROUP = "chat-page-left-panel-tooltip-create-group";
var QUERY_STRING_TYPE_INVTED = "request";


/***/ }),

/***/ 19546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cu": function() { return /* binding */ InputSearchContainer; },
/* harmony export */   "E": function() { return /* binding */ FooterActionButton; },
/* harmony export */   "EG": function() { return /* binding */ RoomItemContent; },
/* harmony export */   "Fi": function() { return /* binding */ RequestActionButtons; },
/* harmony export */   "KY": function() { return /* binding */ RoomItemBody; },
/* harmony export */   "M3": function() { return /* binding */ RoomListContainer; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "NS": function() { return /* binding */ GroupAvatar; },
/* harmony export */   "Og": function() { return /* binding */ RoomItemStatus; },
/* harmony export */   "V9": function() { return /* binding */ PanelHeader; },
/* harmony export */   "WR": function() { return /* binding */ ButtonHeaderRequestAction; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "Z4": function() { return /* binding */ LoadingMore; },
/* harmony export */   "_c": function() { return /* binding */ DeletedLastMessage; },
/* harmony export */   "bk": function() { return /* binding */ FooterContainer; },
/* harmony export */   "c": function() { return /* binding */ NewChatCount; },
/* harmony export */   "lk": function() { return /* binding */ PanelContainer; },
/* harmony export */   "mw": function() { return /* binding */ AvatarContainer; },
/* harmony export */   "oI": function() { return /* binding */ PopoverChatSettingWrapper; },
/* harmony export */   "s6": function() { return /* binding */ IconNewChat; },
/* harmony export */   "sd": function() { return /* binding */ RequestHeaderContainer; },
/* harmony export */   "xn": function() { return /* binding */ WebHeaderContainer; },
/* harmony export */   "yV": function() { return /* binding */ ButtonUnstyled; },
/* harmony export */   "z5": function() { return /* binding */ ChatItem; }
/* harmony export */ });
/* unused harmony exports ShimmerListRoomContainer, Shimmer, RequestNumberContainer, LeftMobileHeaderContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41080);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37949);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_company_Navbar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26226);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Popover__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70187);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 90%;\n  display: flex;\n  align-items: center;\n  font-style: italic;\n  color: #858585;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  width: 100vw;\n  max-width: 100%;\n  height: 100%;\n  position: relative;\n  @media ",
        " {\n    border-right: none;\n    display: block;\n    width: 400px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  height: calc(100% - 61px);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-left: 5px solid ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  /* height : 75px; */\n  border-bottom: 1px solid ",
        ";\n  cursor : pointer;\n  padding-left: ",
        ";\n  padding-right: 20px;\n  padding-top: 14px;\n  padding-bottom: 15px;\n\n  &:hover, &:active, &:focus {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  height: 24px;\n  min-width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 24px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-skeleton-title {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .ant-skeleton-paragraph {\n    margin-top: 10px !important;\n    margin-bottom: 0px !important;\n  }\n  margin-bottom: 36px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 21px 24px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  top: 0;\n  height: auto;\n  transition: 0.5s;\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  button {\n    height: 32px;\n  }\n\n  #chat-search-back-button {\n    position: absolute;\n    left: -35px;\n    transition: 0.2s;\n  }\n\n  #chat-search-new-chat-button {\n    position: relative;\n    right: 0;\n    transition: 0.5s;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 32px;\n    height: 32px;\n    span {\n      height: 3px;\n      width: 3px;\n      background: #dadada;\n    }\n  }\n\n  ",
        " {\n    border-radius: 4px;\n    margin-left: unset;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n  :before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n  }\n  :before {\n    content: '';\n    border-radius: 50%;\n    border-top: 2px solid #ccc;\n    border-right: 2px solid transparent;\n    animation: ",
        " 0.7s linear infinite;\n    -webkit-animation: ",
        " 0.7s linear infinite;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: 'space-between';\n  align-items: 'center';\n  flex-grow: 1;\n\n  p > img {\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: calc(100% - 100px);\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 60px);\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {\n    width: 16px;\n  }\n  & > :last-child {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n  i {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-right: 12px;\n\n  & > img {\n    border-radius: 50%;\n    width: 46px;\n    height: 46px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  height: 32px;\n\n  :hover {\n    border-color: ",
        " !important;\n  }\n\n  input::placeholder,\n  input::-webkit-input-placeholder {\n    color: #e4e4e4 !important;\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px;\n  }\n\n  .ant-input-clear-icon {\n    display: flex;\n    color: rgba(0, 0, 0, 0.5);\n  }\n\n  #chat-left-contact-search-close {\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  color: ",
        ";\n  text-align: right;\n  cursor: pointer;\n  1 :hover {\n    background: none;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 15px;\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n    width: 18px;\n    height: 18px;\n    position: relative;\n\n    :after {\n      left: 3.5px !important;\n      top: 7px !important;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n  .ant-checkbox-disabled .ant-checkbox-inner {\n    border-color: ",
        "!important;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n  padding: 20px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-bold);\n  cursor: pointer;\n\n  img {\n    margin-right: 10px;\n  }\n\n  :hover {\n    background: none;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 2.5px;\n  align-items: center;\n  width: 80px;\n  justify-content: flex-end;\n  > button {\n    margin-left: 0 !important;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}













var DeletedLastMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-0"
})(_templateObject());
var PanelContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        visible: props.visible
    };
}).withConfig({
    componentId: "sc-9c134656-1"
})(_templateObject1(), function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var PanelHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    padding: "14px 20px",
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-9c134656-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper);
var IconNewChat = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper);
var RoomListContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-4"
})(_templateObject4());
var ChatItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
})// @ts-expect-error
.attrs(function(props) {
    return {
        active: props.active,
        align: "center"
    };
}).withConfig({
    componentId: "sc-9c134656-5"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, function(param) {
    var active = param.active;
    return active ? "16px" : "20px";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue);
}, function(props) {
    return(// @ts-expect-error
    props.cursorActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue));
});
var NewChatCount = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light,
    size: "11px",
    align: "center",
    padding: "2px"
}).withConfig({
    componentId: "sc-9c134656-6"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var ShimmerListRoomContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-7"
})(_templateObject9());
var Shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).attrs({
    avatar: true,
    paragraph: {
        rows: 1
    },
    loading: true
}).withConfig({
    componentId: "sc-9c134656-8"
})(_templateObject10());
var RequestHeaderContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-9"
})(_templateObject11(), function(param) {
    var visible = param.visible;
    return !visible && "\n    top: -50px;\n    transition: .5s;\n    width: 100%;\n    background-color: #fff;\n    height: 0;\n    padding: 0 16px;\n  ";
});
var LeftMobileHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-10"
})(_templateObject12(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mobileL */ .Z.mobileL);
var ButtonUnstyled = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c134656-11"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].downgray */ .Z.downgray);
var InputSearchContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-12"
})(_templateObject14(), function(param) {
    var isFocus = param.isFocus;
    return isFocus && "\n    #chat-search-back-button {\n      position: relative;\n      left: 0;\n      transition: 0.5s;\n    }\n    #chat-search-new-chat-button {\n      position: absolute;\n      right: -90px;\n      transition: .5s;\n    }\n  ";
});
var PopoverChatSettingWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Popover__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-9c134656-13"
})(_templateObject15(), _deprecated_ui_company_Navbar__WEBPACK_IMPORTED_MODULE_9__/* .NavMore */ .J, _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
var RequestNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-14"
})(_templateObject16(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mobileL */ .Z.mobileL);
var WebHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-15"
})(_templateObject17());
var loadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .keyframes */ .F4)(_templateObject18());
var LoadingMore = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-16"
})(_templateObject19(), loadingAnimation, loadingAnimation);
var RoomItemContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-9c134656-17"
})(_templateObject20());
var RoomItemBody = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-18"
})(_templateObject22(), function(param) {
    var hasCheckbox = param.hasCheckbox;
    return hasCheckbox && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject21());
});
var RoomItemStatus = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-19"
})(_templateObject23());
var GroupAvatar = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c134656-20"
})(_templateObject24());
var AvatarContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-21"
})(_templateObject25(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].component */ .Z.component, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lowgray */ .Z.lowgray);
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    type: "text"
}).withConfig({
    componentId: "sc-9c134656-22"
})(_templateObject26(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var ButtonHeaderRequestAction = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c134656-23"
})(_templateObject27(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9c134656-24"
})(_templateObject28(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lowgray */ .Z.lowgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lowgray */ .Z.lowgray);
var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-25"
})(_templateObject29(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var FooterActionButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c134656-26"
})(_templateObject30());
var RequestActionButtons = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c134656-27"
})(_templateObject31());



/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ editPriceAlertSelector; },
/* harmony export */   "NS": function() { return /* binding */ cancelPriceAlertSelector; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "TB": function() { return /* binding */ priceAlertSelector; },
/* harmony export */   "_b": function() { return /* binding */ alertLogSelector; },
/* harmony export */   "az": function() { return /* binding */ addPriceAlertSelector; }
/* harmony export */ });
/* unused harmony exports PRICE_ALERT_TYPE, selectors, reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56703);






// Auth Related Modules

// Actions
var CONTEXT = "@side-widget/priceAlert";
var actionType = {
    GET_PRICE_ALERT: "".concat(CONTEXT, "/GET_PRICE_ALERT"),
    ADD_PRICE_ALERT: "".concat(CONTEXT, "/ADD_PRICE_ALERT"),
    EDIT_PRICE_ALERT: "".concat(CONTEXT, "/EDIT_PRICE_ALERT"),
    CANCEL_PRICE_ALERT: "".concat(CONTEXT, "/CANCEL_PRICE_ALERT"),
    GET_ALERT_LOG: "".concat(CONTEXT, "/GET_ALERT_LOG")
};
// price alert type
var PRICE_ALERT_TYPE = {
    PRICE_ALERT: "priceAlert",
    ALERT_LOG: "alertLog"
};
// initial state
var initialState = {
    priceAlert: {
        data: [],
        isLoading: true,
        error: null,
        page: 1,
        reachEnd: false
    },
    addPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isSubmit: false
    },
    editPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isSubmit: false
    },
    cancelPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isCancel: false
    },
    alertLog: {
        data: [],
        isLoading: true,
        error: null
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    var _priceAlert = state.mainLayout.priceAlert, priceAlert = _priceAlert.priceAlert, addPriceAlert = _priceAlert.addPriceAlert, editPriceAlert = _priceAlert.editPriceAlert, cancelPriceAlert = _priceAlert.cancelPriceAlert, alertLog = _priceAlert.alertLog;
    return {
        // all
        priceAlert: priceAlert,
        alertLog: alertLog,
        addPriceAlert: addPriceAlert,
        editPriceAlert: editPriceAlert,
        cancelPriceAlert: cancelPriceAlert,
        // price alert
        priceAlertError: priceAlert.error,
        priceAlertData: priceAlert.data,
        priceAlertLoading: priceAlert.isLoading,
        // alert log
        alertLogError: alertLog.error,
        alertLogData: alertLog.data,
        alertLogLoading: alertLog.isLoading
    };
}, function(state) {
    return state;
});
var priceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.priceAlert;
}, function(state) {
    return state;
});
var addPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.addPriceAlert;
}, function(state) {
    return state;
});
var editPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.editPriceAlert;
}, function(state) {
    return state;
});
var cancelPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.cancelPriceAlert;
}, function(state) {
    return state;
});
var alertLogSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.alertLog;
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    setPriceAlert: function(state, action) {
        state.priceAlert.data = state.priceAlert.data.filter(function(x) {
            return String(x.alert_id) !== String(action.payload.alert_id);
        });
    }
};
// effects
var effects = {
    // getPriceAlert
    getPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_PRICE_ALERT, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, page, limit, opt, response, _data, data, _$error, message, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {
                        page: 1,
                        limit: 30
                    };
                    _ctx.prev = 1;
                    page = options.page, limit = options.limit;
                    opt = {
                        page: page || 1,
                        limit: limit || 30
                    };
                    _ctx.next = 6;
                    return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDataPriceAlert */ .Z.getDataPriceAlert(opt);
                case 6:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error("Error when get list price alert");
                case 9:
                    _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error(_$error);
                case 12:
                    return _ctx.abrupt("return", {
                        data: data,
                        options: options,
                        message: message
                    });
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }))),
    // getAlertLog
    getAlertLog: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_ALERT_LOG, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var opt, response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    opt = {
                        page: 1,
                        limit: 30
                    };
                    _ctx.next = 4;
                    return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDataAlertLog */ .Z.getDataAlertLog(4, opt);
                case 4:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Error when get list alert log");
                case 7:
                    _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    throw new Error(_$error);
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }))),
    // addPriceAlert
    addPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.ADD_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, command, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, command = param.command;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].addPriceAlert */ .Z.addPriceAlert(name, command);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when add price alert");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editPriceAlert
    editPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.EDIT_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var alertId, name, command, response, _data, data, _$error, message, updatedAlert;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        alertId = param.alertId, name = param.name, command = param.command;
                        _ctx.prev = 1;
                        if (alertId) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Alert ID is required!");
                    case 4:
                        _ctx.next = 6;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].editPriceAlert */ .Z.editPriceAlert(alertId, name, command);
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Error when edit price alert");
                    case 9:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(_$error);
                    case 12:
                        updatedAlert = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                            command: JSON.parse(command)
                        });
                        return _ctx.abrupt("return", {
                            updatedAlert: updatedAlert,
                            data: data,
                            message: message
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // cancelPriceAlert
    cancelPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.CANCEL_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].cancelPriceAlert */ .Z.cancelPriceAlert(id);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when cancel price alert");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            id: id,
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra / Async Reducer
var extraReducers = function(builder) {
    builder.addCase(effects.getPriceAlert.pending, function(state) {
        state.priceAlert.error = null;
        state.priceAlert.isLoading = true;
    }).addCase(effects.getPriceAlert.fulfilled, function(state, action) {
        if (action.payload.options.page > 1) {
            state.priceAlert.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.priceAlert.data).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(action.payload.data));
        } else {
            // To prevent data duplication when sidemenu is reopened / switching tab
            state.priceAlert.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(action.payload.data);
        }
        // Update `page` when data is not empty
        if (action.payload.data.length > 0) {
            state.priceAlert.page = action.payload.options.page;
            state.priceAlert.reachEnd = false;
        } else {
            state.priceAlert.reachEnd = true;
        }
        state.priceAlert.error = null;
        state.priceAlert.isLoading = false;
        state.priceAlert.message = action.payload.message;
    }).addCase(effects.getPriceAlert.rejected, function(state, action) {
        state.priceAlert.error = action.error;
        state.priceAlert.isLoading = false;
    }).addCase(effects.getAlertLog.pending, function(state) {
        state.alertLog.error = null;
        state.alertLog.isLoading = true;
    }).addCase(effects.getAlertLog.fulfilled, function(state, action) {
        state.alertLog.data = action.payload.data;
        state.alertLog.error = null;
        state.alertLog.isLoading = false;
        state.alertLog.message = action.payload.message;
    }).addCase(effects.getAlertLog.rejected, function(state, action) {
        state.alertLog.error = action.error;
        state.alertLog.isLoading = false;
    }).addCase(effects.addPriceAlert.pending, function(state) {
        state.addPriceAlert.error = null;
        state.addPriceAlert.isLoading = true;
        state.addPriceAlert.isSubmit = false;
    }).addCase(effects.addPriceAlert.fulfilled, function(state, action) {
        state.addPriceAlert.data = action.payload.data;
        var alert = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, action.payload.data), {
            command: JSON.parse(action.payload.data.command)
        });
        state.priceAlert.data = [
            alert
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.priceAlert.data));
        state.addPriceAlert.error = null;
        state.addPriceAlert.isLoading = false;
        state.addPriceAlert.message = action.payload.message;
        state.addPriceAlert.isSubmit = true;
    }).addCase(effects.addPriceAlert.rejected, function(state, action) {
        state.addPriceAlert.error = action.error;
        state.addPriceAlert.isLoading = false;
        state.addPriceAlert.isSubmit = false;
    }).addCase(effects.editPriceAlert.pending, function(state) {
        state.editPriceAlert.error = null;
        state.editPriceAlert.isLoading = true;
        state.editPriceAlert.isSubmit = false;
    }).addCase(effects.editPriceAlert.fulfilled, function(state, action) {
        state.editPriceAlert.data = action.payload.data;
        var updatedAlert = action.payload.updatedAlert;
        var index = state.priceAlert.data.findIndex(function(x) {
            return x.alert_id === updatedAlert.alert_id;
        });
        if (index > -1) {
            state.priceAlert.data[index] = updatedAlert;
        }
        state.editPriceAlert.error = null;
        state.editPriceAlert.isLoading = false;
        state.editPriceAlert.message = action.payload.message;
        state.editPriceAlert.isSubmit = true;
    }).addCase(effects.editPriceAlert.rejected, function(state, action) {
        state.editPriceAlert.error = action.error;
        state.editPriceAlert.isLoading = false;
        state.editPriceAlert.isSubmit = false;
    }).addCase(effects.cancelPriceAlert.pending, function(state) {
        state.cancelPriceAlert.error = null;
        state.cancelPriceAlert.isLoading = true;
        state.cancelPriceAlert.isCancel = false;
    }).addCase(effects.cancelPriceAlert.fulfilled, function(state, action) {
        state.cancelPriceAlert.data = action.payload.data;
        var id = action.payload.id;
        state.priceAlert.data = state.priceAlert.data.filter(function(x) {
            return x.alert_id !== id;
        });
        state.cancelPriceAlert.error = null;
        state.cancelPriceAlert.isLoading = false;
        state.cancelPriceAlert.message = action.payload.message;
        state.cancelPriceAlert.isCancel = true;
    }).addCase(effects.cancelPriceAlert.rejected, function(state, action) {
        state.cancelPriceAlert.error = action.error;
        state.cancelPriceAlert.isLoading = false;
        state.cancelPriceAlert.isCancel = false;
    });
};
// Slice
var priceAlertSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "priceAlert",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (priceAlertSlice);


/***/ }),

/***/ 48153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony exports availableMenu, initialState, effects, reducers */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61876);

// constants
var availableMenu = [
    {
        key: "ALL_WATCHLIST",
        icon: "icon-widget_watchlist",
        text: "Watchlist",
        eventName: "watchlist"
    },
    {
        key: "PRICE_ALERT",
        icon: "icon-widget_alert",
        text: "Price Alert",
        eventName: "price_alert"
    },
    {
        key: "RUNNING_TRADE",
        icon: "icon-widget_runningtrade",
        text: "Running Trade",
        eventName: "running_trade"
    },
    {
        key: "HOTLIST",
        icon: "icon-widget_hotlist",
        text: "Hotlist",
        eventName: "hotlist"
    },
    {
        key: "VALUATION",
        icon: "icon-widget_valuation",
        text: "Valuation",
        eventName: "valuation"
    },
    {
        key: "BANDAR_DETECTOR",
        icon: "icon-widget_bandar",
        text: "Bandar Detector",
        eventName: "bandar_detector"
    }, 
];
// initial state
var initialState = {
    // current: availableMenu[0].key,
    current: null,
    isSideWidgetOpen: false,
    isHeaderMinimized: false,
    isReloginModalOpen: false,
    errorCode: null,
    bandarDetectorActiveKey: "BROKER_SUMMARY",
    isFromBandarDetector: false,
    isMarketOpen: true
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.root;
}, function(state) {
    return {
        current: state.current,
        isSideWidgetOpen: state.isSideWidgetOpen,
        isReloginModalOpen: state.isReloginModalOpen,
        isHeaderMinimized: state.isHeaderMinimized,
        errorCode: state.errorCode,
        bandarDetectorActiveKey: state.bandarDetectorActiveKey,
        isMarketOpen: state.isMarketOpen
    };
});
// Async Actions / Side Effects
var effects = {};
// Reducer
var reducers = {
    setActiveWidget: function(draft, action) {
        if (draft.isSideWidgetOpen && action.payload.key === draft.current && !action.payload.isFromBandarDetector) {
            draft.current = null;
            draft.isSideWidgetOpen = false;
        } else {
            draft.current = action.payload.key;
            draft.isSideWidgetOpen = true;
        }
        if (action.payload.key === availableMenu[5].key) {
            if (action.payload.bandarDetectorActiveKey) {
                draft.bandarDetectorActiveKey = action.payload.bandarDetectorActiveKey;
            } else {
                draft.bandarDetectorActiveKey = "BROKER_SUMMARY";
            }
        }
    },
    setIsMarketOpen: function(state, action) {
        state.isMarketOpen = action.payload;
    },
    setErrorCode: function(state, action) {
        state.errorCode = action.payload;
        state.isReloginModalOpen = true;
    },
    setHeaderMinimized: function(state, action) {
        state.isHeaderMinimized = action.payload;
    },
    resetState: function(state) {
        state.current = null;
        state.isSideWidgetOpen = false;
        state.isHeaderMinimized = false;
        state.isReloginModalOpen = false;
        state.errorCode = null;
    }
};
// Extra Reducer
var extraReducers = {};
// Slice
var mainSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "mainLayout",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (mainSlice);


/***/ }),

/***/ 77667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fi": function() { return /* binding */ showAlertNotification; },
  "Ac": function() { return /* binding */ showChatNotification; },
  "uw": function() { return /* binding */ showGeneralNotification; }
});

// UNUSED EXPORTS: createPush

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/chat/LeftSidebar/ChatRooms/RoomItemAvatar.tsx
var RoomItemAvatar = __webpack_require__(92235);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./node_modules/push.js/bin/push.min.js
var push_min = __webpack_require__(28874);
var push_min_default = /*#__PURE__*/__webpack_require__.n(push_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./node_modules/react-string-replace-recursively/index.js
var react_string_replace_recursively = __webpack_require__(54253);
var react_string_replace_recursively_default = /*#__PURE__*/__webpack_require__.n(react_string_replace_recursively);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/global/Notification/utils.ts



var parseNotificationMessage = function(text, maskedHtml) {
    var parseHtmlMask = function(mask) {
        if (Array.isArray(maskedHtml)) {
            var parsed = mask.reduce(function(obj, curr) {
                // eslint-disable-next-line no-param-reassign
                obj[curr.mask] = curr;
                return obj;
            }, {});
            return parsed;
        }
        return mask;
    };
    var parsedText = (0,stream/* parseEmoji */.qm)(text);
    var parsedHtml = parseHtmlMask(maskedHtml);
    var config = {
        breaks: {
            pattern: /(\n|\r\n)/g,
            matcherFn: function() {
                return react.createElement("br");
            }
        },
        symbols: {
            pattern: /(\[%[a-z0-9_]*%\])/gi,
            textFn: function(text) {
                var cleanedSymbol = text.match(/\w+/g);
                return cleanedSymbol;
            },
            matcherFn: function(rawText) {
                var htmlData = parsedHtml[rawText];
                var _attr = htmlData.attr, attr = _attr === void 0 ? {} : _attr, _$text = htmlData.text, tag = htmlData.tag;
                return react.createElement(tag, {}, _$text);
            }
        }
    };
    parsedText = react_string_replace_recursively_default()(config)(parsedText);
    return parsedText;
};


;// CONCATENATED MODULE: ./src/global/Notification/index.tsx
/* eslint-disable import/prefer-default-export */ 











var prefix = "".concat(app/* assetPrefix */.Vc, "/images");
function createPush() {
    var title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Stockbit", msg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", ref = arguments.length > 2 ? arguments[2] : void 0, tag = ref.tag, timeout = ref.timeout, icon = ref.icon, callBack = arguments.length > 3 ? arguments[3] : void 0;
    if (!(push_min_default())) throw new Error("push js not exists");
    var configuration = {
        body: msg,
        timeout: 4000,
        onClick: callBack
    };
    if (tag) configuration.tag = tag;
    if (timeout) configuration.timeout = timeout;
    if (icon) configuration.icon = icon;
    push_min_default().create(title, configuration);
}
var showChatNotification = function(param) {
    var title = param.title, description = param.description, isDeactivate = param.isDeactivate, name = param.name, shortName = param.shortName, type = param.type, avatar = param.avatar, id = param.id, _key = param.key, key = _key === void 0 ? "open".concat(Date.now()) : _key, isPersonalChat = param.isPersonalChat, isInvitedChat = param.isInvitedChat, onClose = param.onClose;
    var handleClick = function() {
        notification/* default.close */.Z.close(key);
        var url = new URL("".concat(window.location.origin));
        switch(type){
            case "ROOM_TYPE_GROUP":
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/group-chat/").concat(id);
                break;
            case "ROOM_TYPE_BROADCAST":
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/broadcast-chat/").concat(id);
                break;
            case "ROOM_TYPE_PERSONAL":
            default:
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat/").concat(id);
                break;
        }
        window.open(url, "_blank");
    };
    if (!router_default().asPath.includes(id)) {
        // browser push notification
        if (document.hidden) {
            var optional = {
                tag: "notif_chatv2_".concat(id),
                timeout: 4000,
                icon: "".concat(prefix, "/stockbitlogo-notification.png")
            };
            var pushNotifAction = function() {
                var baseURL = "".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV);
                var pathName = isPersonalChat ? "chat" : "group-chat";
                // accepted room chat
                var urlPushNotif = "".concat(baseURL, "/").concat(pathName, "/").concat(id, "?source=").concat(constant/* CHAT_PUSH_NOTIFICATION_INDEX */.bg);
                // requested room chat
                if (isInvitedChat) {
                    urlPushNotif = "".concat(baseURL, "/").concat(pathName, "/").concat(id, "?type=request&source=").concat(constant/* CHAT_PUSH_NOTIFICATION_INDEX */.bg);
                }
                window.focus();
                window.open(urlPushNotif, "_blank");
            };
            return createPush(title, description, optional, function() {
                pushNotifAction();
                if (this && typeof this.close === "function") this.close();
            });
        }
        notification/* default.open */.Z.open({
            key: key,
            className: "float-chat-notification",
            placement: "bottomLeft",
            message: title,
            description: (0,utils/* removeFormat */.Ir)(description),
            duration: 7,
            onClick: handleClick,
            onClose: onClose,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomItemAvatar/* default */.Z, {
                isDeactive: isDeactivate,
                name: name,
                shortName: shortName,
                type: type,
                src: avatar
            })
        });
    }
    return null;
};
var showGeneralNotification = function(notifData, onClose) {
    var ref, ref1;
    var baseURL = "".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV);
    var actionUrl = "";
    var showNotif = true;
    var message = "Stockbit"; // default message
    var icon = "";
    var textValue = "";
    var maskedHtml = notifData === null || notifData === void 0 ? void 0 : (ref = notifData.data) === null || ref === void 0 ? void 0 : ref.message_mask;
    if (showNotif && (notifData === null || notifData === void 0 ? void 0 : (ref1 = notifData.data) === null || ref1 === void 0 ? void 0 : ref1.avatar)) {
        icon = notifData.data.avatar;
    }
    if (maskedHtml) {
        // get the username
        textValue = Object.keys(maskedHtml).reduce(function(_, curr) {
            return maskedHtml ? "".concat(maskedHtml[curr].text) : "";
        }, "");
    }
    switch(parseInt(notifData.type, 10)){
        case 3:
            // Go to user profile
            actionUrl = "".concat(baseURL, "/").concat(notifData.data.link_to.identifier);
            break;
        case 4:
            // Go to company page
            actionUrl = "".concat(baseURL, "/symbol/").concat(notifData.data.link_to.identifier);
            break;
        case 2:
        case 5:
        case 6:
        case 7:
        case 9:
        case 12:
            // Go to post page
            actionUrl = "".concat(baseURL, "/post/").concat(notifData.data.link_to.identifier);
            break;
        // case '22':
        case 21:
        case 23:
            actionUrl = "".concat(baseURL, "/tip/").concat(notifData.data.link_to.identifier);
            break;
        case 42:
            showNotif = true;
            if (textValue) {
                actionUrl = "".concat(baseURL, "/community?search=").concat(textValue);
            } else {
                actionUrl = "".concat(baseURL, "/community");
            }
            message = "External Community";
            icon = "/images/stockbit-bubble-white.png";
            break;
        case 44:
        case 45:
            actionUrl = "".concat(baseURL, "/securities/portfolio");
            break;
        default:
            actionUrl = "";
            break;
    }
    if (showNotif) {
        var messageText = notifData.data.message;
        var parsedText = parseNotificationMessage(messageText, maskedHtml);
        notification/* default.open */.Z.open({
            key: "notification-".concat(notifData.id),
            className: "float-general-notification",
            placement: "bottomLeft",
            message: message,
            description: parsedText,
            duration: 7,
            onClose: onClose,
            onClick: function() {
                return window.open(actionUrl, "_blank");
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: icon,
                    onError: function(e) {
                        return (0,general/* handleErrorAvatar */.Tk)(e, "Stockbit");
                    },
                    style: {
                        width: "48px",
                        height: "48px"
                    }
                })
            })
        });
    }
};
var showAlertNotification = function(notifData, onClose) {
    notification/* default.open */.Z.open({
        key: "notification-".concat(notifData === null || notifData === void 0 ? void 0 : notifData.alert_id),
        className: "float-alert-notification",
        placement: "bottomLeft",
        message: "Stockbit",
        description: notifData === null || notifData === void 0 ? void 0 : notifData.msg,
        duration: 7,
        onClose: onClose,
        onClick: function() {
            return notification/* default.close */.Z.close("notification-".concat(notifData === null || notifData === void 0 ? void 0 : notifData.alert_id));
        },
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: 71,
                height: 71
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/stockbit-logo-notif.png",
                onError: function(e) {
                    return (0,general/* handleErrorAvatar */.Tk)(e, "Stockbit");
                },
                style: {
                    objectFit: "contain"
                }
            })
        })
    });
};



/***/ }),

/***/ 79030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ MAX_FILE_SIZE_MB; },
/* harmony export */   "EZ": function() { return /* binding */ IMAGE_TYPE_COMMON; },
/* harmony export */   "Jo": function() { return /* binding */ MAX_IMAGE_SIZE_MB; },
/* harmony export */   "Tb": function() { return /* binding */ MAX_FILE_SIZE; },
/* harmony export */   "Wk": function() { return /* binding */ initialTargetPrice; },
/* harmony export */   "ZX": function() { return /* binding */ COMPOSE_MODE; },
/* harmony export */   "fg": function() { return /* binding */ initialPolling; },
/* harmony export */   "l2": function() { return /* binding */ COMMENT_SETTING_LIST; },
/* harmony export */   "n0": function() { return /* binding */ MAX_IMAGE_SIZE; },
/* harmony export */   "ox": function() { return /* binding */ ALLOWED_DOC_EXT; },
/* harmony export */   "p$": function() { return /* binding */ IMAGE_TYPE_GIF; },
/* harmony export */   "vS": function() { return /* binding */ ADMIN_USER_PRIVILEGE; }
/* harmony export */ });
var ALLOWED_DOC_EXT = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpointtd",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
];
// max file size: 0MB
var MAX_FILE_SIZE_MB = 10;
var MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
var MAX_IMAGE_SIZE_MB = 2;
var MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_MB * 1024 * 1024;
var COMPOSE_MODE = {
    COMPOSE: "compose",
    EDIT: "edit",
    REPOST: "repost",
    SHARE: "share",
    SHARE_TEXT: "share-link"
};
var initialPolling = {
    isOpen: false,
    duration: {
        Days: 1,
        Hours: 0,
        Mins: 0
    },
    polling_pin: 0,
    polling_options: [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: ""
        }, 
    ],
    polling_end: 0
};
var initialTargetPrice = {
    isOpen: false,
    target_duration: "7",
    target_price: 0,
    target_symbol: ""
};
var IMAGE_TYPE_GIF = "GIF";
var IMAGE_TYPE_COMMON = "COMMON";
var COMMENT_SETTING_LIST = [
    {
        id: 1,
        label: "Everyone",
        type: "COMMENTER_TYPE_EVERYONE",
        icon: "comment-globe.svg"
    },
    {
        id: 2,
        label: "Only people you follow",
        type: "COMMENTER_TYPE_FOLLOWING",
        icon: "comment-people.svg"
    },
    {
        id: 3,
        label: "Only people you mention",
        type: "COMMENTER_TYPE_MENTION",
        icon: "comment-mention.svg"
    },
    {
        id: 4,
        label: "Only you",
        type: "COMMENTER_TYPE_ONLY_YOU",
        icon: "comment-private.svg"
    }, 
];
var ADMIN_USER_PRIVILEGE = [
    "1",
    "2",
    "4"
];



/***/ }),

/***/ 23985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ wsKeySelector; },
/* harmony export */   "Fy": function() { return /* binding */ streamWsSelector; },
/* harmony export */   "Nw": function() { return /* binding */ actions; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "i9": function() { return /* binding */ notifWsSelector; },
/* harmony export */   "m5": function() { return /* binding */ alertWsSelector; },
/* harmony export */   "mD": function() { return /* binding */ wsStatusSelector; }
/* harmony export */ });
/* unused harmony exports selectors, channelsSelector, websocketListeningSelector, actionType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61876);
/* harmony import */ var lib_api_ws__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66679);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19225);
/* harmony import */ var utils_webSocket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92953);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2497);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77667);
/* harmony import */ var global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-plusplus */ /* eslint-disable no-console */ 







// APIs


// Utils





var PRICE_ALERT_KEY = "price-alert";
var setPriceAlertToLocalStorage = function(alert) {
    try {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.setItem(PRICE_ALERT_KEY, JSON.stringify(alert));
        return true;
    } catch (e) {
        return false;
    }
};
// Initial state
var initialState = {
    wskey: null,
    status: "3",
    auth: 0,
    listening: false,
    livedata_channels: {
        stream: [],
        company: [],
        orderbook: [],
        hotlist: false
    },
    // socket data may be wrong, dependent on how it will be used
    // feel free to adjust it
    socket_data: {
        stream: null,
        notification: [],
        alert: null
    }
};
var wsSelector = function(state) {
    return state.websocket;
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(wsSelector, function(ws) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, ws);
});
var wsKeySelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.wskey;
}, function(state) {
    return state;
});
var notifWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.notification;
}, function(state) {
    return state;
});
var alertWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.alert;
}, function(state) {
    return state;
});
var channelsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.livedata_channels;
}, function(state) {
    return state;
});
var websocketListeningSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.listening;
}, function(state) {
    return state;
});
var wsStatusSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.status;
}, function(state) {
    return state;
});
var streamWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.stream;
}, function(state) {
    return state;
});
// Actions
var CONTEXT = "@redux/websocket";
var actionType = {
    INIT_WEBSOCKET: "".concat(CONTEXT, "/INIT_WEBSOCKET"),
    INIT_LISTEN_DATA: "".concat(CONTEXT, "/INIT_LISTEN_DATA"),
    INIT_CONFIG: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/INIT_CONFIG")),
    UPDATE_ACTIVE_STATUS: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/UPDATE_ACTIVE_STATUS")),
    UPDATE_CHANNELS_CONFIG: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/UPDATE_CHANNELS_CONFIG")),
    ADD_SOCKET_DATA: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/ADD_SOCKET_DATA"))
};
var actions = actionType;
// API actions
var getWskey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, error, message, data, wsKey;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_ws__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getWSKey */ .Z.getWSKey();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get wskey failed");
                case 6:
                    _data = response.data, error = _data.error, message = _data.message, data = _data.data;
                    if (!error) {
                        _ctx.next = 9;
                        break;
                    }
                    // @ts-ignore
                    throw new Error({
                        error: error,
                        message: message
                    });
                case 9:
                    wsKey = utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].convertWSKeyArray */ .Z.convertWSKeyArray(data.key);
                    utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].setLocalWskey */ .Z.setLocalWskey(wsKey);
                    return _ctx.abrupt("return", wsKey);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    return _ctx.abrupt("return", null);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function getWskey() {
        return _ref.apply(this, arguments);
    };
}();
// effects
var attempt = 0;
var effects = {
    initWebsocket: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.INIT_WEBSOCKET, /**
     * Initiate websocket
     * @param {Object} param
     * @param {Object} param.primus - primus
     * @param {boolean} param.isUserLogin - flag if user is logged in
     */ // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var primus, ref, dispatch, getState, ref1, _entities, _credentials, isUserLogin, status, parsedCookie, token, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    primus = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, ref = _args.length > 1 ? _args[1] : void 0, dispatch = ref.dispatch, getState = ref.getState;
                    ref1 = getState(), _entities = ref1.// @ts-ignore
                    entities, _credentials = _entities.credentials, isUserLogin = _credentials.isLoggedIn, // @ts-ignore
                    status = ref1.websocket.status;
                    parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    token = parsedCookie.accessToken.token;
                    if (!(primus === null || !isUserLogin || !token)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("No websocket active");
                case 6:
                    if (token) {
                        // @ts-ignore
                        primus.on("open", function() {
                            ;
                            var cookie = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                            var _accessToken = cookie.accessToken, accessToken = _accessToken.token;
                            if (accessToken) {
                                getWskey().then(function(key) {
                                    if (Array.isArray(key)) {
                                        var _key = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(key, 1), useWsKey = _key[0];
                                        // @ts-ignore
                                        dispatch(actionType.INIT_CONFIG({
                                            primus: primus,
                                            wskey: useWsKey
                                        }));
                                        ;
                                    // on connection open, get websocket key
                                    // every time we refresh the page we will re-fetch ws key
                                    // thus we always get wskey from api
                                    }
                                });
                            }
                            return true;
                        });
                        // @ts-ignore
                        primus.on("end", function(e) {
                            ;
                            ;
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            // update status
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                            return false;
                        });
                        // @ts-ignore
                        primus.on("reconnect", function() {
                            ;
                            ;
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                            // Close primus connection if attempt reconnection >= 3 times
                            if (attempt >= 3) {
                                // @ts-ignore
                                primus.end();
                            }
                        });
                        // @ts-ignore
                        primus.on("reconnected", function() {
                            ;
                        });
                        // @ts-ignore
                        primus.on("reconnect failed", function() {
                            ;
                            ;
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                        });
                        // @ts-ignore
                        primus.on("error", function(e) {
                            ;
                            ;
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                        });
                    }
                    return _ctx.abrupt("return", true);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    initListenData: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.INIT_LISTEN_DATA, // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var primus, ref, dispatch, getState, ref1, _websocket, statusWebsocket, currentPages, batchPages, isBatch, batchOperation, INTERVAL_DURATION, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    primus = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, ref = _args.length > 1 ? _args[1] : void 0, dispatch = ref.dispatch, getState = ref.getState;
                    if (primus) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 3:
                    ref1 = getState(), _websocket = ref1.// @ts-ignore
                    websocket, statusWebsocket = _websocket.status;
                    currentPages = (next_router__WEBPACK_IMPORTED_MODULE_4___default().asPath);
                    batchPages = [
                        "catalog",
                        "sector",
                        "stream"
                    ];
                    isBatch = batchPages.some(function(item) {
                        return currentPages.includes(item);
                    });
                    batchOperation = [];
                    INTERVAL_DURATION = 700;
                    if (currentPages.includes("watchlist")) {
                        INTERVAL_DURATION = 200;
                    }
                    if (isBatch) {
                        setInterval(function() {
                            if (batchOperation.length > 0) {
                                (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .batch */ .dC)(function() {
                                    batchOperation.map(function(action) {
                                        return dispatch(action);
                                    });
                                    batchOperation = [];
                                });
                            }
                        }, INTERVAL_DURATION);
                    }
                    // @ts-ignore
                    primus.on("data", function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
                            var ref, authtext, onlineStatus, alert;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        if (statusWebsocket !== "3" && data.__i) {
                                            authtext = data.__i.toLowerCase();
                                            if (authtext === "auth_ok") {
                                                ;
                                                // @ts-ignore
                                                dispatch(actionType.UPDATE_ACTIVE_STATUS("3"));
                                            }
                                        }
                                        if (statusWebsocket === "3" && data.__e) {
                                            if (data.__e.includes("Unauthorized Connection")) {
                                                onlineStatus = window.navigator.onLine ? "2" : "1";
                                                // @ts-ignore
                                                if (statusWebsocket !== onlineStatus) {
                                                    // @ts-ignore
                                                    dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                                                }
                                            }
                                        }
                                        if (((ref = data.S) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                stream: data.S[0]
                                            }));
                                        }
                                        if (data.A) {
                                            alert = data.A;
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                alert: alert
                                            }));
                                            if (alert && alert.msg) {
                                                // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                (0,global_Notification__WEBPACK_IMPORTED_MODULE_6__/* .showAlertNotification */ .fi)(alert, function() {});
                                                dispatch(global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__/* ["default"].actions.setPriceAlert */ .ZP.actions.setPriceAlert(alert));
                                                dispatch(global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__/* .effects.getAlertLog */ .Sz.getAlertLog());
                                                setPriceAlertToLocalStorage(alert);
                                            }
                                        }
                                        if (data.N2) {
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                notification: data.N2
                                            }));
                                        }
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(data) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return _ctx.abrupt("return", true);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })))
};
// reducers
var reducers = {
    clearAlert: function(state) {
        state.socket_data.alert = null;
    },
    clearNotification: function(state, action) {
        var newNotification = state.socket_data.notification.filter(function(notif) {
            return notif.id !== action.payload;
        });
        state.socket_data.notification = newNotification;
    },
    resetNotification: function(state) {
        state.socket_data.notification = [];
    },
    setAlert: function(state, action) {
        state.socket_data.alert = action.payload;
    }
};
// Extra reducers
var extraReducers = function(builder) {
    builder.addCase(actionType.INIT_CONFIG, function(state, action) {
        var _payload = action.payload, primus = _payload.primus, wskey = _payload.wskey;
        var currentState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state);
        state.wskey = wskey;
        state.status = "3";
        // initiate config to ws
        utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].initConfig */ .Z.initConfig(primus, currentState, wskey);
    }).addCase(actionType.INIT_LISTEN_DATA, function(state) {
        state.listening = true;
    }).addCase(actionType.UPDATE_ACTIVE_STATUS, function(state, action) {
        var status = action.payload;
        if (state.status !== status) {
            state.status = status;
        }
    })// update current live channels config
    .addCase(actionType.UPDATE_CHANNELS_CONFIG, function(state, action) {
        var newChannelsConfig = action.payload;
        var currentState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state);
        var _livedata_channels = currentState.livedata_channels, orderbook = _livedata_channels.orderbook, company = _livedata_channels.company;
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.livedata_channels, newChannelsConfig);
        // TODO: Improve state update from multiple components
        if (Array.isArray(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.company)) {
            var newCompanies = Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(company).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.company))));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, newState), {
                company: newCompanies
            });
        }
        if (Array.isArray(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.orderbook)) {
            var newOrderbook = Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(orderbook).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.orderbook))));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, newState), {
                orderbook: newOrderbook
            });
        }
        var shouldUpdateConfig = utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateGeneralWsConfig */ .Z.updateGeneralWsConfig(currentState, newState);
        var updatedChannel = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.livedata_channels, shouldUpdateConfig || {});
        if (shouldUpdateConfig) {
            state.livedata_channels = updatedChannel;
        }
        // update and write websocket
        utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateConfig */ .Z.updateConfig(window === null || window === void 0 ? void 0 : window.primus, updatedChannel, currentState.wskey);
    }).addCase(actionType.ADD_SOCKET_DATA, function(state, action) {
        var _payload = action.payload, notification = _payload.notification, socketData = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_payload, [
            "notification"
        ]);
        if (notification) {
            if (!state.socket_data.notification.find(function(notif) {
                return notif.id === notification.id;
            })) {
                state.socket_data.notification = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(state.socket_data.notification).concat([
                    notification, 
                ]);
            }
        }
        state.socket_data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.socket_data, socketData);
    });
};
var webSocketSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
    name: "websocket",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (webSocketSlice);


/***/ }),

/***/ 99368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O7": function() { return /* binding */ getUnreadNotificationNumber; },
/* harmony export */   "v6": function() { return /* binding */ getNotification; },
/* harmony export */   "zJ": function() { return /* binding */ markAsRead; }
/* harmony export */ });
/* unused harmony exports getNotificationSetting, setNotificationSettings */
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var NOTIFICATION_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/notification");
var NOTIFICATION_READ_V2 = "".concat(NOTIFICATION_URL, "s/read");
var NOTIFICATION_SETTINGS = "".concat(NOTIFICATION_URL, "/settings");
var NOTIFICATION_UNREAD_COUNT_V2 = "".concat(NOTIFICATION_URL, "/count/unread");
/**
 * Get notification
 * @param {Array|null=} types - notification types
 * @param {number|string=} limit - limit
 * @param {number|string=} last_id - last id
 * @returns {APIResponse}
 */ var getNotification = function() {
    var types = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 25, last_id = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    // Using URLSearchParams to prevent types params converted to ?types[]=any&types[]=any
    // Because it shoulbe ?types=any&types=any
    var params = (0,utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .convertParams */ .h$)({
        types: types,
        limit: limit,
        last_id: last_id
    });
    return request.get("".concat(NOTIFICATION_URL), {
        params: params
    });
};
/**
 * Read unread notification
 * @param {string} type - notification types
 * @returns {APIResponse}
 */ var markAsRead = function() {
    var types = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return request.patch(NOTIFICATION_READ_V2, {
        types: types
    });
};
/**
 * Get notification settings
 * @param {string} type - notification types
 * @param {string} categories - setting categories
 * @returns {APIResponse}
 */ var getNotificationSetting = function(type, categories) {
    return request.get(NOTIFICATION_SETTINGS, {
        params: {
            type: type,
            categories: categories
        }
    });
};
/**
 * Set up notification settings per category
 * @param {string} type - notification types
 * @param {string} category - setting's category
 * @param {boolean} value - setting's category value (true | false)
 * @returns {APIResponse}
 */ var setNotificationSettings = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return request.put("".concat(NOTIFICATION_SETTINGS, "/update"), {
        type: type,
        setting: _define_property({}, category, value)
    });
};
/**
 * Get unread notification count
 * @returns {APIResponse}
 */ var getUnreadNotificationNumber = function() {
    var types = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTypeUnreadParams */ .Wj;
    var params = (0,utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .convertParams */ .h$)({
        types: types
    });
    return request.get(NOTIFICATION_UNREAD_COUNT_V2, {
        params: params
    });
};


/***/ }),

/***/ 79644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ VerifiedStatus; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ 
var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
// Configs
var VERIFIED_BADGE_URL = "/verified-badge";
var VERIFIED_BADGE_USER_URL = "".concat(VERIFIED_BADGE_URL, "/user");
/**
 * Get verified badge user
 * @param {Number} userId - userid
 * @return {AxiosResponse}
 */ var getVerifiedBadgeUser = function(userId) {
    return requestExodus.get("".concat(VERIFIED_BADGE_USER_URL, "/").concat(userId));
};
var VerifiedStatus;
(function(VerifiedStatus) {
    VerifiedStatus["VERIFIED_STATUS_UNVERIFIED"] = "VERIFIED_STATUS_UNVERIFIED";
    VerifiedStatus["VERIFIED_STATUS_IDENTITY"] = "VERIFIED_STATUS_IDENTITY";
    VerifiedStatus["VERIFIED_STATUS_COMMUNITY"] = "VERIFIED_STATUS_COMMUNITY";
})(VerifiedStatus || (VerifiedStatus = {}));
// Exports ---------------------------------------------------------------------

/* harmony default export */ __webpack_exports__["Z"] = ({
    getVerifiedBadgeUser: getVerifiedBadgeUser
});


/***/ }),

/***/ 333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ profile; },
  "Sz": function() { return /* binding */ effects; },
  "Cr": function() { return /* binding */ proExpirySelector; },
  "Rd": function() { return /* binding */ profileSelector; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState, userIdSelector

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/lib/api/verifiedBadge.ts
var verifiedBadge = __webpack_require__(79644);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/index.js

var schema = {
    id: "",
    username: "",
    fullname: "",
    email: "",
    activated: "",
    banned: "0",
    user_banned_until: "",
    ban_reason: null,
    last_login: "",
    created: "",
    modified: "",
    avatar: "",
    about: "",
    location: "",
    website: "",
    occupation: "",
    gender: "",
    birthday: "",
    phone: "",
    address: "",
    hide_email: "0",
    user_attr: "",
    user_priv: "0",
    tutorial: "0",
    user_newsletter: "",
    country: "ID",
    exchange: "",
    facebook_id: null,
    apple_id: null,
    google_id: null,
    email_subscribe: "",
    user_phone_verification: "",
    facebook_hide: "",
    language: "",
    user_preferences: {},
    user_trading: "",
    user_badge_top: "",
    followed: 0,
    ispro: 0,
    pro_active_since: "",
    pro_expire_at: "",
    tradingpro: 0,
    official: 0,
    trending: 0,
    ir_symbol: "",
    isblocked: 0,
    alert: 0,
    onboarding: 0,
    onboarding_done: 0,
    discover: 0,
    ftcode: "",
    ftend: "",
    realtrading_access: 0,
    top_badge: 0,
    is_term_agreed: 0,
    onesignal_hash: "",
    password: 0,
    support: {
        id: ""
    }
};
var propTypes = {
    id: prop_types.string,
    username: prop_types.string,
    fullname: prop_types.string,
    email: prop_types.string,
    activated: prop_types.string,
    banned: prop_types.string,
    user_banned_until: prop_types.string,
    ban_reason: prop_types.string,
    last_login: prop_types.string,
    created: prop_types.string,
    modified: prop_types.string,
    avatar: prop_types.string,
    about: prop_types.string,
    location: prop_types.string,
    website: prop_types.string,
    occupation: prop_types.string,
    gender: prop_types.string,
    birthday: prop_types.string,
    phone: prop_types.string,
    address: prop_types.string,
    user_attr: prop_types.string,
    user_newsletter: prop_types.string,
    country: prop_types.string,
    exchange: prop_types.string,
    hide_email: prop_types.string,
    user_priv: prop_types.string,
    tutorial: prop_types.string,
    facebook_id: prop_types.string,
    apple_id: prop_types.string,
    google_id: prop_types.string,
    email_subscribe: prop_types.string,
    user_phone_verification: prop_types.string,
    facebook_hide: prop_types.string,
    language: prop_types.string,
    user_preferences: (0,prop_types.oneOfType)([
        prop_types.object,
        prop_types.any
    ]),
    user_trading: prop_types.string,
    user_badge_top: prop_types.string,
    followed: prop_types.number,
    ispro: prop_types.number,
    pro_active_since: prop_types.string,
    pro_expire_at: prop_types.string,
    tradingpro: prop_types.number,
    official: prop_types.number,
    trending: prop_types.number,
    ir_symbol: prop_types.string,
    isblocked: prop_types.number,
    alert: prop_types.number,
    onboarding: prop_types.number,
    onboarding_done: prop_types.number,
    discover: prop_types.number,
    ftcode: prop_types.string,
    ftend: prop_types.string,
    onesignal_hash: prop_types.string,
    realtrading_access: prop_types.number,
    top_badge: prop_types.number,
    is_term_agreed: prop_types.number,
    password: prop_types.number
};
/* harmony default export */ var models_user = ({
    schema: schema,
    propTypes: propTypes
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/utils/userResponseMapping.ts



var formatDate = function(date) {
    return moment_default()(date).format("YYYY-MM-DD HH:mm:ss");
};
var userResponseMapping = function(data) {
    var id = data.id, created_at = data.created_at, statistics = data.statistics, profile = data.profile, privilege = data.privilege, exchange = data.exchange, ir_symbols = data.ir_symbols, badges = data.badges, is_alert_enabled = data.is_alert_enabled, is_blocked = data.is_blocked, is_followed = data.is_followed, email = data.email, last_modified_at = data.last_modified_at, last_login_at = data.last_login_at, is_activated = data.is_activated, has_password = data.has_password, is_newsletter_subscriber = data.is_newsletter_subscriber, is_phone_verified = data.is_phone_verified, is_shown_in_discovery = data.is_shown_in_discovery, preferences = data.preferences, onboarding = data.onboarding, free_trial = data.free_trial, sns = data.sns, trading = data.trading, support = data.support, pro = data.pro, ban = data.ban, onesignal_hash = data.onesignal_hash;
    var follower_count = statistics.follower_count, following_count = statistics.following_count, reputation_count = statistics.reputation_count, idea_count = statistics.idea_count, like_count = statistics.like_count, view_count = statistics.view_count;
    var username = profile.username, fullname = profile.fullname, about = profile.about, website = profile.website, avatar = profile.avatar, country = profile.country, language = profile.language, gender = profile.gender, location = profile.location, address = profile.address, birthday = profile.birthday, phone = profile.phone, occupation = profile.occupation;
    var result = {
        id: String(id),
        username: username,
        fullname: fullname,
        email: email,
        activated: is_activated ? "1" : "0",
        banned: String(ban.code),
        user_banned_until: formatDate(ban.until),
        ban_reason: ban.reason === "" ? null : ban.reason,
        last_login: formatDate(last_login_at),
        created: formatDate(created_at),
        modified: formatDate(last_modified_at),
        avatar: avatar.default,
        about: about,
        location: location,
        website: website,
        occupation: occupation,
        gender: gender,
        birthday: birthday,
        phone: phone.formatted,
        address: address,
        hide_email: preferences.privacy.is_hide_email ? "1" : "0",
        // user_attr
        user_priv: String(privilege.code),
        // tutorial
        // user_newsletter
        country: country,
        exchange: exchange,
        facebook_id: sns.facebook_id,
        apple_id: sns.apple_id,
        google_id: sns.google_id,
        email_subscribe: is_newsletter_subscriber ? "1" : "0",
        user_phone_verification: is_phone_verified ? "1" : "0",
        facebook_hide: preferences.privacy.is_hide_facebook ? "1" : "0",
        language: language,
        user_preferences: {
            stream_version: preferences.stream.version
        },
        user_trading: String(trading.account_id),
        // user_badge_top
        additional: {
            reputations: reputation_count,
            followers: String(follower_count),
            ideas: String(idea_count),
            following: String(following_count),
            likes: like_count,
            views: view_count
        },
        followed: is_followed ? 1 : 0,
        ispro: trading.is_pro || pro.is_pro || !moment_default()().isAfter(free_trial.expired_at) ? 1 : 0,
        pro_active_since: formatDate(pro.active_since),
        pro_expire_at: formatDate(pro.expired_at),
        tradingpro: trading.is_pro ? 1 : 0,
        // official
        trending: badges.is_trending ? 1 : 0,
        ir_symbol: ir_symbols,
        isblocked: is_blocked ? 1 : 0,
        alert: is_alert_enabled ? 1 : 0,
        onboarding: onboarding.current_step,
        onboarding_done: onboarding.is_done ? 1 : 0,
        discover: is_shown_in_discovery ? 1 : 0,
        ftcode: free_trial.code,
        ftend: formatDate(free_trial.expired_at),
        realtrading_access: trading.has_realtrading_access ? 1 : 0,
        top_badge: badges.is_top ? 1 : 0,
        // is_term_agreed
        intercom: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, support.intercom), {
            email: support.intercom.email,
            created_at: support.intercom.created_at,
            phone: support.intercom.phone
        }),
        password: has_password ? 1 : 0,
        onesignal_hash: onesignal_hash,
        support: {
            id: support.id
        }
    };
    return result;
};

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/lib/entities/profile.js







// api
// import { AWS_AVATAR_BUCKET } from 'constants/api';


// Utils


// model



// initial state
var initialState = {
    data: models_user.schema,
    isLoading: true,
    error: null,
    message: "",
    // for flagging btn back is clicked
    isClickedPreviousButton: false,
    connectSocialMedia: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile;
}, function(state) {
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        message: state.message,
        isClickedPreviousButton: state.isClickedPreviousButton,
        connectSocialMedia: state.connectSocialMedia
    };
});
var profileSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data;
});
var proExpirySelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data.pro_expire_at;
});
var userIdSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data.id;
}, function(id) {
    return id;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    FETCH_PROFILE: "".concat(CONTEXT, "/FETCH_PROFILE"),
    UPDATE_PROFILE: "".concat(CONTEXT, "/UPDATE_PROFILE"),
    CONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/CONNECT_SOCIAL_MEDIA"),
    UPDATE_PREFERENCE: "".concat(CONTEXT, "/UPDATE_PREFERENCE")
};
// effects
var effects = {
    // getTrendinguser -------------------------------------------------------------------
    getUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(username) {
            var response, _data, data, message, _$error, userId, _$username, email, avatar, responseGetVerifiedBadge, mappedData, isEmitenUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.getUserProfile */.Z.getUserProfile(username);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 18;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        userId = data.id ? Number(data.id) : 0;
                        _$username = data.profile && data.profile.username || "";
                        email = data.email || "";
                        avatar = data.profile && data.profile.avatar && data.profile.avatar.default || "";
                        _ctx.next = 12;
                        return verifiedBadge/* default.getVerifiedBadgeUser */.Z.getVerifiedBadgeUser(userId);
                    case 12:
                        responseGetVerifiedBadge = _ctx.sent;
                        if (!_$error) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 15:
                        mappedData = userResponseMapping(data);
                        // Clevertap pprofile initialization
                        if (responseGetVerifiedBadge && responseGetVerifiedBadge.data) {
                            isEmitenUser = responseGetVerifiedBadge.data && responseGetVerifiedBadge.data.is_emitten || false;
                            // Track if username is empty
                            if (!_$username) {
                                (0,logger/* default */.ZP)(new Error("[CT initialization Error]: username is empty"), {
                                    place: "src/lib/entities/profile.js",
                                    event: "getUserProfile",
                                    eventParam: {
                                        profile: data.profile
                                    }
                                });
                            }
                            (0,clevertap/* clevertapProfilingUser */.$b)({
                                isInitProfile: true,
                                identity: _$username,
                                email: email,
                                profilePictureUrl: avatar,
                                isEmitenUser: isEmitenUser
                            });
                        }
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message
                        });
                    case 18:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editUserProfile -------------------------------------------------------------------
    editUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
            var preventUpdate, body, response, _data, data, message, _$error, sanitizedData, mappedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        preventUpdate = requestBody.preventUpdate, body = (0,_object_without_properties/* default */.Z)(requestBody, [
                            "preventUpdate"
                        ]);
                        _ctx.next = 4;
                        return user/* default.editUserProfile */.Z.editUserProfile(body);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        sanitizedData = (0,_object_spread/* default */.Z)({}, data);
                        mappedData = userResponseMapping(data);
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message,
                            preventUpdate: preventUpdate
                        });
                    case 12:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // userConnectSocialMedia -------------------------------------------------------------------
    userConnectSocialMedia: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var socialMediaName, requestBody, dispatch, response, _data, data, message, _$error, userAccess, usernameAuth;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMediaName = param.socialMediaName, requestBody = param.requestBody, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.userConnectSocialMedia */.Z.userConnectSocialMedia(socialMediaName, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        userAccess = auth/* default.getUserAccess */.Z.getUserAccess();
                        usernameAuth = userAccess.username;
                        dispatch(effects.getUserProfile(usernameAuth));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        throw new Error("Attempt to connect social media Failed");
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePreference: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PREFERENCE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestData) {
            var response, _data, data, error, error_type, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.updatePreference */.Z.updatePreference(requestData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt update preference failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                        if (!(error || error_type)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(message);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * updateOnboardingStep
   * Store back onboarding progress step
   * @param step - object of previous progress step
   * @param isClickedPreviousButton - boolean
   */ updateOnboardingStep: function(draft, action) {
        var step = action.payload.step;
        var newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.data), {
            onboarding: step
        });
        draft.data = newData;
    },
    /**
   * resetIsClickedPreviousButton
   * change isClickedPreviousButton to false
   */ resetIsClickedPreviousButton: function(draft) {
        draft.isClickedPreviousButton = false;
    },
    /**
   * reset profile state
   */ resetProfileState: function(draft) {
        draft.data = models_user.schema;
    }
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var extraReducers = (_obj = {}, // Get Userprofile -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.getUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.data = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post editUserProfile -----------------------------------------------------------
// replace state profile
(0,_define_property/* default */.Z)(_obj, effects.editUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, preventUpdate = _payload.preventUpdate;
    if (error) {
        state.error = error;
    } else {
        // to handle when user has clicked previous button
        // used last onboarding step from state
        // to be used in button next
        var isClickedPreviousButton = state.isClickedPreviousButton;
        var _data = state.data, lastProgress = _data.onboarding;
        var newDataWithLastProgress = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
            onboarding: lastProgress
        });
        if (!preventUpdate) {
            state.data = isClickedPreviousButton ? newDataWithLastProgress : data;
        }
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post userConnectSocialMedia -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.pending, function(state) {
    state.connectSocialMedia.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.connectSocialMedia.error = error;
    } else {
        state.connectSocialMedia.data = data;
    }
    state.connectSocialMedia.message = message;
    state.connectSocialMedia.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.rejected, function(state, action) {
    state.connectSocialMedia.error = action.payload.error;
    state.connectSocialMedia.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var profileSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "profile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var profile = (profileSlice);


/***/ }),

/***/ 25178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "In": function() { return /* binding */ notificationCategories; },
/* harmony export */   "QV": function() { return /* binding */ disorganizeNormalizedNotification; },
/* harmony export */   "UC": function() { return /* binding */ notificationTypesWithAvatar; },
/* harmony export */   "WE": function() { return /* binding */ normalizeNotification; },
/* harmony export */   "Wj": function() { return /* binding */ notificationTypeUnreadParams; },
/* harmony export */   "h$": function() { return /* binding */ convertParams; },
/* harmony export */   "jg": function() { return /* binding */ notificationTabsAttrs; },
/* harmony export */   "x8": function() { return /* binding */ parseNotificationMessage; }
/* harmony export */ });
/* unused harmony exports notificationTypesMap, mergeNotificationCategories, filterNotificationItems */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var react_string_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59632);
/* harmony import */ var react_string_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_string_replace__WEBPACK_IMPORTED_MODULE_0__);


/**
 * Notification types mapping
 */ var notificationTypesMap = {
    company: [
        "NOTIF_TYPE_NEW_REPORT"
    ],
    stream: [
        "NOTIF_TYPE_MENTIONS",
        "NOTIF_TYPE_REPLY"
    ],
    other: [
        "NOTIF_TYPE_FOLLOWING",
        "NOTIF_TYPE_RETWEET",
        "NOTIF_TYPE_LIKE",
        "NOTIF_TYPE_STREAMS_UPDATE",
        "NOTIF_TYPE_POSTALERT",
        "NOTIF_TYPE_STOCK_ALERT",
        "NOTIF_TYPE_TARGETPRICE",
        "NOTIF_TYPE_TRADING_MATCH_ORDER",
        "NOTIF_TYPE_TRADING_COMMUNITY",
        "NOTIF_TYPE_STREAMS_UPDATE",
        "NOTIF_TYPE_NEW_TRENDING",
        "NOTIF_TYPE_CALENDAR",
        "NOTIF_TYPE_NEWSFEED",
        "NOTIF_TYPE_GROUPCHAT_INVITE",
        "NOTIF_TYPE_VERIFIED_BADGE",
        "NOTIF_TYPE_SAVE",
        "NOTIF_TYPE_SECURITIES_DAY_TRADE",
        "NOTIF_TYPE_SHARIA_STOCK_DELISTED", 
    ],
    tipping: [
        "NOTIF_TYPE_TIPPING_RECEIVER",
        "NOTIF_TYPE_TIPPING_SENDER",
        "NOTIF_TYPE_CLAIM", 
    ]
};
var notificationTypeUnreadParams = [
    "NOTIF_TYPE_INBOX",
    "NOTIF_TYPE_MENTIONS",
    "NOTIF_TYPE_FOLLOWING",
    "NOTIF_TYPE_RETWEET",
    "NOTIF_TYPE_REPLY",
    "NOTIF_TYPE_LIKE",
    "NOTIF_TYPE_SAVE",
    "NOTIF_TYPE_POSTALERT",
    "NOTIF_TYPE_TRADING_MATCH_ORDER",
    "NOTIF_TYPE_NEW_TRENDING",
    "NOTIF_TYPE_STOCK_ALERT",
    "NOTIF_TYPE_NEWUSERJOIN",
    "NOTIF_TYPE_TARGETPRICE",
    "NOTIF_TYPE_TIPPING_RECEIVER",
    "NOTIF_TYPE_TIPPING_SENDER",
    "NOTIF_TYPE_CLAIM",
    "NOTIF_TYPE_VERIFIED_BADGE",
    "NOTIF_TYPE_SECURITIES_DAY_TRADE",
    "NOTIF_TYPE_SHARIA_STOCK_DELISTED",
    "NOTIF_TYPE_SECURITIES_DEPOSIT",
    "NOTIF_TYPE_SECURITIES_WITHDRAW",
    "NOTIF_TYPE_SECURITIES_REFERRAL",
    "NOTIF_TYPE_SECURITIES_MATCH",
    "NOTIF_TYPE_SECURITIES_REJECT",
    "NOTIF_TYPE_MESSAGE_REQUEST",
    "NOTIF_TYPE_EIPO_CONFIRMATION",
    "NOTIF_TYPE_GROUPCHAT",
    "NOTIF_TYPE_NEW_REPORT",
    "NOTIF_TYPE_NEWSFEED",
    "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE",
    "NOTIF_TYPE_COMPANY_SHAREHOLDING",
    "NOTIF_TYPE_COMPANY_DIVIDEND",
    "NOTIF_TYPE_COMPANY_CORP_ACTION",
    "NOTIF_TYPE_COMPANY_OTHERS",
    "NOTIF_TYPE_TRADING_COMMUNITY", 
];
var notificationReportType = [
    "NOTIF_TYPE_NEW_REPORT",
    "NOTIF_TYPE_NEWSFEED",
    "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE",
    "NOTIF_TYPE_COMPANY_SHAREHOLDING",
    "NOTIF_TYPE_COMPANY_DIVIDEND",
    "NOTIF_TYPE_COMPANY_CORP_ACTION",
    "NOTIF_TYPE_COMPANY_OTHERS", 
];
/**
 * Tabs attributes (className, name, typeCodes)
 */ var notificationTabsAttrs = [
    {
        name: "notification",
        className: "icon-notification_activity",
        // typeCodes: '3,5,6,7,9,12,16',
        typeCodes: notificationTypeUnreadParams
    },
    {
        name: "mention",
        className: "icon-notification_mention",
        typeCodes: [
            "NOTIF_TYPE_MENTIONS"
        ]
    },
    {
        name: "report",
        className: "icon-notification_report",
        typeCodes: notificationReportType
    },
    {
        name: "tipping",
        className: "icon-notification_tip",
        typeCodes: [
            "NOTIF_TYPE_TIPPING_RECEIVER",
            "NOTIF_TYPE_TIPPING_SENDER",
            "NOTIF_TYPE_CLAIM", 
        ]
    }, 
];
/**
 * Notification categories
 */ var notificationCategories = {
    reports: notificationReportType,
    replies: [
        "NOTIF_TYPE_REPLY"
    ],
    tipping: [
        "NOTIF_TYPE_TIPPING_RECEIVER",
        "NOTIF_TYPE_TIPPING_SENDER"
    ],
    tradingMatchOrder: [
        "NOTIF_TYPE_TRADING_MATCH_ORDER"
    ],
    trending: [
        "NOTIF_TYPE_NEW_TRENDING"
    ],
    verified: [
        "NOTIF_TYPE_VERIFIED_BADGE"
    ],
    dayTrade: [
        "NOTIF_TYPE_SECURITIES_DAY_TRADE"
    ]
};
/**
 * Notification types that includes avatar
 */ // export const notificationTypesWithAvatar = [1, 2, 3, 5, 7, 9, 12, 20, 42];
var notificationTypesWithAvatar = [
    "NOTIF_TYPE_INBOX",
    "NOTIF_TYPE_MENTIONS",
    "NOTIF_TYPE_FOLLOWING",
    "NOTIF_TYPE_RETWEET",
    "NOTIF_TYPE_LIKE",
    "NOTIF_TYPE_SAVE",
    "NOTIF_TYPE_POSTALERT",
    "NOTIF_TYPE_TARGETPRICE",
    "NOTIF_TYPE_REPLY",
    "NOTIF_TYPE_TRADING_COMMUNITY", 
];
/**
 * Normalize notification data (copy-pasted from legacy code)
 * @param {Object} data - raw data
 * @returns {Object}
 */ var normalizeNotification = function(data) {
    var generated = {
        count: {
            company: 0,
            stream: 0,
            other: 0,
            tipping: 0
        },
        content: {
            company: [],
            stream: [],
            other: [],
            tipping: []
        }
    };
    if (!data) {
        return generated;
    }
    if (data.length === 0) {
        return generated;
    }
    var hashmap = {};
    data.forEach(function(v) {
        if (!hashmap[v.id]) {
            // check if hashmap data not found
            hashmap[v.id] = true;
            Object.keys(notificationTypesMap).forEach(function(name) {
                var index = notificationTypesMap[name].findIndex(function(mapv) {
                    return mapv === v.type;
                });
                if (index > -1) {
                    generated.count[name] += 1;
                    generated.content[name].push(v);
                }
            });
        }
    });
    return generated;
};
/**
 * Turn normalized data to its origin form
 * @param {Object} data - normalized data
 * @returns {Object}
 */ var disorganizeNormalizedNotification = function(data) {
    if (!data.company || !data.stream || !data.other) {
        return [];
    }
    var map = [];
    Object.keys(data).forEach(function(name) {
        map = map.concat(data[name]);
    });
    return map;
};
/*
 * Parse notification message
 * @Author: stockbit6
 * @Date:   2017-10-17 13:19:47
 * @Last Modified by:   stockbit6
 * @Last Modified time: 2018-01-10 10:02:20
 *
 * TODO:
 *
 * This is copy pasted from legacy code. Only
 * renaming some variables to match with properties
 * passed down from parent component or save myself
 * from linter error.
 *
 * It is unreadable but battle-tested since 2017.
 * I need to consult the author of this snippet and
 * then come back here knowing what this parser is
 * trying to do. No explanation whatsoever.
 *
 * UPDATED:
 * This function is used for format message from masked
 * property response.
 */ var parseNotificationMessage = function(props) {
    var selection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var message = props.message, mask = props.mask, render = props.render;
    var tag = props.tag;
    // reset mask
    mask = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(mask);
    if (selection) {
        var selected = props[selection];
        if (selected.message) {
            message = selected.message || "";
            mask = selected.mask || {};
        }
    }
    if (!render) render = function(currentContent) {
        return currentContent;
    };
    if (!message) message = "";
    if (message.indexOf("\n") > -1) {
        mask.push({
            key: "brbrbr",
            payload: {
                tag: "br",
                text: ""
            }
        });
        message = message.replace(/[\r\n]{2,}/g, "\n\n");
        message = message.split("\n").map(function(value) {
            return "".concat(value, " [%brbrbr%] ");
        }).join("");
    }
    var currentContent = message;
    if (message.indexOf("[%") < 0 || message.indexOf("%]") < 0) {
        if (typeof currentContent === "string" && typeof props.renderParseString === "function") {
            return props.renderParseString(currentContent);
        }
        return render(message, tag);
    }
    // eslint-disable-next-line array-callback-return
    mask.map(function(item) {
        var search = "[%".concat(item.key, "%]");
        var result = message.indexOf(search) > -1;
        if (result) {
            currentContent = react_string_replace__WEBPACK_IMPORTED_MODULE_0___default()(currentContent, search, function() {
                var text = "";
                var tagInside = "";
                text = item.payload.text ? item.payload.text : text;
                // Convert PAYLOAD_MASK_TAG_BOLD to b
                tagInside = item.payload.tag === "PAYLOAD_MASK_TAG_BOLD" ? "b" : item.payload.tag;
                return parseNotificationMessage({
                    message: text,
                    tag: tagInside,
                    mask: mask,
                    render: render
                });
            });
        }
    });
    if (typeof currentContent.map === "function") {
        currentContent = currentContent.map(function(item) {
            if (typeof item === "string" && typeof props.renderParseString === "function" && item) {
                return props.renderParseString(item);
            }
            return item;
        });
    }
    if (typeof currentContent === "string" && typeof props.renderParseString === "function" && currentContent) {
        return props.renderParseString(currentContent);
    }
    return currentContent;
};
/**
 *
 * @param {object} content - Broadcast content. See
 * @returns
 */ var mergeNotificationCategories = function(content) {
    return [].concat(content.stream, content.company, content.other, content.tipping)// @ts-ignore
    .sort(function(a, b) {
        return new Date(b.created) - new Date(a.created);
    });
}; // Sorted by most recent
/**
 * Filter out notification items
 * @param {string} tab - Notification tab name (activity, mention, report, tipping)
 * @returns (content: {}) => {array}
 */ var filterNotificationItems = function(tab) {
    return function(content) {
        var list = [];
        switch(tab){
            case "notification":
                return mergeNotificationCategories(content);
            case "mention":
                return content.stream;
            case "report":
                return content.company;
            case "tipping":
                return content.tipping;
            default:
                return list;
        }
    };
};
var convertParams = function(params) {
    var convertedParams = new URLSearchParams();
    if (params.types && params.types.length > 0) {
        params.types.map(function(type) {
            return convertedParams.append("types", type);
        });
    }
    if (params.limit) {
        convertedParams.append("limit", params.limit);
    }
    if (params.last_id) {
        convertedParams.append("last_id", params.last_id);
    }
    return convertedParams;
};


/***/ }),

/***/ 14601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HM": function() { return /* binding */ isReadMoreShow; },
/* harmony export */   "Hm": function() { return /* binding */ cleanupStreamPayload; },
/* harmony export */   "Nk": function() { return /* binding */ parseExistImage; },
/* harmony export */   "P9": function() { return /* binding */ getYoutubeVideoId; },
/* harmony export */   "PI": function() { return /* binding */ transformConversationV3; },
/* harmony export */   "Zu": function() { return /* binding */ getYoutubeURL; },
/* harmony export */   "bv": function() { return /* binding */ transformV3Response; },
/* harmony export */   "hp": function() { return /* binding */ transformStreamV3; },
/* harmony export */   "qm": function() { return /* binding */ parseEmoji; },
/* harmony export */   "vO": function() { return /* binding */ parseStreamPostContent; }
/* harmony export */ });
/* unused harmony export countWords */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79030);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-useless-escape */ /* eslint-disable import/prefer-default-export */ 




/**
 * Function to parse post content to data which can be read in
 * component `StreamCompose`
 * @param {Object} post - Post object
 * @return {Object} parsed post
 */ var parseEmoji = function(textContent) {
    return textContent;
};
var parseStreamPostContent = function(post) {
    var content = post.content_original, images = post.images, imagesData = post.images_data, attachment = post.attachment, targetPrice = post.target_price, commenterType = post.commenter_type, postId = post.postid, parentPostId = post.parent_postid;
    var parsedContent = {
        content: parseEmoji(content),
        images: images,
        images_data: imagesData,
        documents: attachment || [],
        targetPrice: null,
        commenter_type: commenterType,
        postId: postId,
        parentPostId: parentPostId
    };
    if ((targetPrice === null || targetPrice === void 0 ? void 0 : targetPrice.length) > 0) {
        parsedContent.targetPrice = {
            target_duration: targetPrice[0].duration,
            target_price: targetPrice[0].target_price,
            target_symbol: targetPrice[0].symbol
        };
    }
    // Polling is not included to parsed content since polling is not editable
    return parsedContent;
};
/**
 * Get last Youtube url from user content
 * @param {string} contentOriginal - original content from stream post
 */ function getYoutubeURL() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?/gm;
    var list = contentOriginal.match(exp);
    if (list && list.length >= 1) {
        return list[list.length - 1];
    }
    return null;
}
/**
 * parse youtube video URL
 * @param {string} youtubeURL - URL of youtube video
 */ function parseYoutubeURL() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]{1,50}\?v=|embed\/|v\/|e\/|live\/|shorts\/)?)([\w\-]{11})(\S+)?$/gm;
    var list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(youtubeURL.matchAll(exp)).map(function(m) {
        return {
            url: m[0],
            protocol: m[1],
            www: m[2],
            host: m[3],
            slug: m[4],
            id: m[5],
            params: m[6]
        };
    });
    return list.length === 1 ? list[0] : null;
}
/**
 * Get youtube video ID from youtube URL
 * @param {string} youtubeURL - URL of youtube video
 */ function getYoutubeVideoId() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    return youtubeURL ? (ref = parseYoutubeURL(youtubeURL)) === null || ref === void 0 ? void 0 : ref.id : null;
}
/**
 * Count words from escaped string
 * @param {string} str
 * @returns {number} words length
 */ var countWords = function(str) {
    var newStr = str.trim();
    newStr = newStr.replace(/[ ]{2,}/gi, " ");
    newStr = newStr.replace(/\n /, "\n");
    return newStr.split(/\s+/).length;
};
var MAX_WORDS = 10;
var MAX_NEWLINE = 2;
/**
 * Decide to show read more flag
 * @param {string} contentOriginal - Original content
 * @param {number=} maxWords - Maximum words
 * @param {number=} maxNewLine - Max paragraph
 * @returns {boolean}
 */ var isReadMoreShow = function() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", maxWords = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_WORDS, maxNewLine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MAX_NEWLINE;
    return countWords(contentOriginal) > maxWords || contentOriginal.split(/\r\n|\r|\n/).length > maxNewLine;
};
/**
 * Parse Etension from Url
 * @param {string} unparsedUrl - url file string
 * @returns {string} - file extension from the url
 */ var parseExtension = function(unparsedUrl) {
    // Remove everything to the last slash in URL
    var url = unparsedUrl.substr(1 + unparsedUrl.lastIndexOf("/"));
    // Break URL at ? and take first part (file name, extension)
    url = url.split("?")[0];
    // Sometimes URL doesn't have ? but #, so we should aslo do the same for #
    url = url.split("#")[0];
    // Now we have only extension
    url = url.split(".").pop();
    return url;
};
/**
 * Parse Images Data Json to parsed Format
 * @param {Array} images - images_data JSON response from api
 * @returns {Array}
 */ var parseExistImage = function(images) {
    var parsedImages = images.map(function(image) {
        return {
            dimensions: {
                width: image.width,
                height: image.height
            },
            imagePreviewUrl: image.image,
            file: image.image,
            isNew: false,
            type: parseExtension(image.image).toLowerCase() === "gif" ? global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_GIF */ .p$ : global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_COMMON */ .EZ
        };
    });
    return parsedImages;
};
/**
 * Convert stream V3 response to stream V2 response
 * @param {Object} stream - stream V3 response
 * @returns {Object} stream V2 response
 */ function transformStreamV3() {
    var stream = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    if (!stream) {
        return stream;
    }
    var UserRole = {
        PRIVILEGE_MEMBER: 0,
        PRIVILEGE_ADMIN: 1,
        PRIVILEGE_MODERATOR: 2,
        PRIVILEGE_CONFIGURATOR: 3,
        PRIVILEGE_SUPER_ADMIN: 4
    };
    var CountryID = {
        COUNTRY_ID: "ID",
        COUNTRY_MY: "MY",
        COUNTRY_SG: "SG"
    };
    var transformBoolean = function(status) {
        return status ? 1 : 0;
    };
    var transformed = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, stream, stream.status, stream.user), {
        country: CountryID[stream.user.country],
        created: stream.created_at,
        follow: transformBoolean(stream.status.is_followed),
        is_author: transformBoolean(stream.user.is_author),
        is_unavailable: stream.status.is_unavailable,
        isnews: transformBoolean(stream.title_url),
        ispinned: transformBoolean(stream.status.is_pinned),
        ispro: transformBoolean(stream.user.is_pro),
        liked: transformBoolean(stream.status.is_liked),
        likes: stream.total_likes,
        newsfeed_img: stream.news_feed.img,
        newsfeed_label: stream.news_feed.label,
        newsfeed_source: stream.news_feed.source,
        official: transformBoolean(stream.user.is_verified),
        parent_postid: stream.parent_stream_id,
        postid: stream.stream_id,
        replies: stream.total_replies.toString(),
        replying_to: transformBoolean(stream.reply_to),
        replyto: stream.reply_to.toString(),
        reposted: transformBoolean(stream.status.is_reposted),
        repostedfrom: transformStreamV3(stream.reposted_from),
        saved: transformBoolean(stream.status.is_saved),
        titleurl: stream.title_url,
        trending: transformBoolean(stream.status.is_trending),
        updated: stream.updated_at,
        user_priv: UserRole[stream.user.user_privilege],
        userid: stream.user.user_id,
        isJunk: Boolean((ref = stream.status) === null || ref === void 0 ? void 0 : ref.is_junk),
        isSpam: Boolean((ref1 = stream.status) === null || ref1 === void 0 ? void 0 : ref1.is_spam)
    });
    if (transformed.last_reply && transformed.last_reply.user) {
        transformed.last_reply = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.last_reply, transformed.last_reply.user), {
            postid: transformed.last_reply.stream_id
        });
        delete transformed.last_reply.user;
    }
    if (transformed.reply_content) {
        transformed.reply_content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.reply_content), {
            titleurl: transformed.reply_content.title_url
        });
        delete transformed.reply_content.title_url;
    }
    delete transformed.user;
    delete transformed.status;
    return transformed;
}
/**
 * Convert stream V3 response to stream V2 response
 * @param {Array} streamList - stream V3 response
 * @returns {Array} stream V2 response
 */ function transformV3Response() {
    var streamList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!streamList) {
        return streamList;
    }
    return streamList.map(transformStreamV3);
}
function transformConversationV3() {
    var conversation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!conversation) {
        return conversation;
    }
    var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, conversation), {
        parent: transformStreamV3(conversation.parent),
        replies: transformV3Response(conversation.replies)
    });
    return payload;
}
/**
 * Remove empty value from object
 * @param {Object} obj
 * @returns {Object}
 * @example
 * const obj = {
 *  a: '',
 * b: null,
 * c: undefined,
 * d: 'd',
 * }
 * cleanupStreamPayload(obj) // { d: 'd' }
 */ function cleanupStreamPayload(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return value !== "" && value !== null && value !== undefined;
    }));
}



/***/ }),

/***/ 92953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19225);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);
/* eslint-disable no-param-reassign */ /* eslint-disable no-console */ /* eslint-disable camelcase */ /* eslint-disable no-plusplus */ 




// WS CONFIG VARIABLES
var WS_LIVEPRICE = true;
var WS_STREAM = true;
var WS_TRADING = true;
/**
 * Parse new socket string data, identified with # property
 * @param  {String} socketString - String you want to parse, returned from socket
 * @return {Object} Parsed socket string in object form
 */ function parseSocketString() {
    var socketString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var parsedRawObject = socketString.split("|");
    var parsedObject = {};
    var priceObjectList = [];
    var hotlistData = [];
    switch(parsedRawObject[0]){
        case "#C":
            parsedObject = {
                C: {
                    sym: parsedRawObject[1],
                    date_unix: Number(parsedRawObject[2]),
                    ohlc: {
                        Adj_Close: Number(parsedRawObject[4]),
                        Close: Number(parsedRawObject[8]),
                        High: Number(parsedRawObject[6]),
                        Low: Number(parsedRawObject[7]),
                        Open: Number(parsedRawObject[5]),
                        volume: Number(parsedRawObject[9]),
                        date_unix: Number(parsedRawObject[2]),
                        date_formated: parsedRawObject[3],
                        dividend: Number(parsedRawObject[13]),
                        foreign_buy: Number(parsedRawObject[14]),
                        foreign_flow: Number(parsedRawObject[15]),
                        foreign_sell: Number(parsedRawObject[16]),
                        frequency: Number(parsedRawObject[17]),
                        marketcap: Number(parsedRawObject[18]),
                        value: Number(parsedRawObject[19]),
                        shareoutstanding: Number(parsedRawObject[20]),
                        ann_eps: Number(parsedRawObject[21]),
                        ann_pe: Number(parsedRawObject[22]),
                        avg_price: Number(parsedRawObject[23]),
                        previous: Number(parsedRawObject[24]),
                        freq_analyzer: Number(parsedRawObject[25])
                    },
                    widget: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, parsedRawObject[1], {
                        lastprice: Number(parsedRawObject[10]),
                        price_change: Number(parsedRawObject[11]),
                        percentage_change: Number(parsedRawObject[12])
                    }),
                    "OFFER-RG": {},
                    "BID-RG": {},
                    __t: parsedRawObject[26]
                },
                __t: parsedRawObject[26]
            };
            break;
        case "#O":
            // eslint-disable-next-line no-case-declarations
            var arrayLength = parsedRawObject.length - 2;
            for(var i = 3; i <= arrayLength; i++){
                // eslint-disable-line no-plusplus
                if (parsedRawObject[i] && typeof parsedRawObject[i] === "string" && parsedRawObject[i].includes(";")) {
                    var splittedPrice = parsedRawObject[i].split(";");
                    var _splittedPrice = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(splittedPrice, 3), price = _splittedPrice[0], queue = _splittedPrice[1], volume = _splittedPrice[2];
                    var priceObject = {
                        price: price,
                        queue: queue,
                        volume: volume
                    };
                    priceObjectList.push(priceObject);
                }
            }
            parsedObject = {
                O: {
                    sym: parsedRawObject[1]
                },
                __t: parsedRawObject[13]
            };
            if (parsedRawObject[2] === "OFFER") {
                parsedObject.O["OFFER-RG"] = {};
                priceObjectList.forEach(function(priceObject, index) {
                    parsedObject.O["OFFER-RG"]["price".concat(index + 1)] = Number(priceObject.price);
                    parsedObject.O["OFFER-RG"]["que_num".concat(index + 1)] = Number(priceObject.queue);
                    parsedObject.O["OFFER-RG"]["volume".concat(index + 1)] = Number(priceObject.volume);
                });
            }
            if (parsedRawObject[2] === "BID") {
                parsedObject.O["BID-RG"] = {};
                priceObjectList.forEach(function(priceObject, index) {
                    parsedObject.O["BID-RG"]["price".concat(index + 1)] = Number(priceObject.price);
                    parsedObject.O["BID-RG"]["que_num".concat(index + 1)] = Number(priceObject.queue);
                    parsedObject.O["BID-RG"]["volume".concat(index + 1)] = Number(priceObject.volume);
                });
            }
            break;
        case "#H":
            for(var i1 = 2; i1 < parsedRawObject.length; i1++){
                // eslint-disable-line no-plusplus
                var companyData = parsedRawObject[i1].split(";");
                if (companyData[0]) {
                    hotlistData[i1 - 2] = {
                        symbol: companyData[0],
                        name: companyData[1],
                        change: Number(companyData[2]),
                        lastprice: Number(companyData[3]),
                        percentage_change: Number(companyData[4]),
                        // for notation and corporate action
                        company_id: Number(companyData[5]),
                        withNotation: Number(companyData[6]) === 1,
                        withUMA: Number(companyData[7]) === 1,
                        withCorpAction: Number(companyData[8]) === 1
                    };
                }
            }
            parsedObject = {
                H: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, parsedRawObject[1], hotlistData)
            };
            break;
        case "#I":
            parsedObject = {
                I: {
                    sym: parsedRawObject[1],
                    date_unix: Number(parsedRawObject[2]),
                    ohlc: {
                        close: Number(parsedRawObject[8]),
                        high: Number(parsedRawObject[6]),
                        low: Number(parsedRawObject[7]),
                        open: Number(parsedRawObject[5]),
                        volume: Number(parsedRawObject[9])
                    }
                }
            };
            break;
        default:
            parsedObject = {
                info: parsedRawObject
            };
            break;
    }
    return parsedObject;
}
var setLocalWskey = function(access_wskey) {
    return (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .saveObject */ .Ex)("ws", access_wskey);
};
var getLocalWskey = function() {
    var ls = window.localStorage;
    try {
        return ls.ws ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .decodeBase64ToJS */ .OB)(ls.ws) : null;
    } catch (e) {
        ;
        return null;
    }
};
var useLocalWskey = function() {
    var ls = window.localStorage;
    var toSend = "";
    var wskey = ls.ws ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .decodeBase64ToJS */ .OB)(ls.ws) : null;
    if (wskey) {
        toSend = wskey.pop();
        setLocalWskey(wskey); // update wskey local
    }
    return toSend;
};
// websocket config methods
/**
 * Get primus config
 * @param {*} c - subscribe company
 * @param {*} s - subscribe stream -> main stream , symbol stream, profile stream
 * @param {*} o - subscribe orderbook
 * @param {*} h - subscribe hotlist
 * @param {*} t - subscribe trading
 * @returns {Object}
 */ function getConfig(c, s, o) {
    var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, t = arguments.length > 4 ? arguments[4] : void 0;
    var user = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    var config = {
        loggedInUser: user === null || user === void 0 ? void 0 : user.id,
        chname: {
            C: [],
            S: [],
            O: [],
            // "C": c || [], // to subscribe company
            // "C": [], // 1 , orderbook , chartbit , company profile, sector
            // "S": ["*.news"], // main stream , symbol stream, profile stream
            // "S": [], // main stream , symbol stream, profile stream
            // "S": s || ["*"], // main stream , symbol stream, profile stream
            // "H": false, // hotlist
            T: [],
            H2: h
        }
    };
    if (WS_LIVEPRICE) config.chname.C = c || [];
    if (WS_STREAM) {
        config.chname.S = s || [];
    }
    if (WS_TRADING) config.chname.T = t || [];
    config.chname.O = o || [];
    return config;
}
/**
 * Write/send/emit subscription data to backend websocket
 * @param {Object} primus - Primus websocket
 * @param {Object} config - WS config
 */ function extendWrite(primus, config) {
    if (!primus) return;
    if (!WS_STREAM) config.chname.S = [];
    if (config.chname.S.length > 0 && config.chname.S[0].toLowerCase().includes("all")) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(config.chname.S[0].split("."), 1), category = ref[0];
        var newConfigChnameS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config.chname.S);
        newConfigChnameS[0] = category;
        config.chname.S = newConfigChnameS;
    }
    primus.write(config);
}
/**
 * Initiate websocket subscription
 * @param {Object} primus - Primus websocket
 * @param {Object} state - Websocket reducer
 * @param {string} wskey
 */ var initConfig = function(primus, state, wskey) {
    var ch = {};
    if (!ch.S) ch.S = state.livedata_channels.stream;
    if (!ch.C) ch.C = state.livedata_channels.company;
    if (!ch.O) ch.O = state.livedata_channels.orderbook;
    var socket_config = getConfig(ch.C, ch.S, ch.O);
    if (wskey) socket_config.wskey = wskey;
    socket_config.chname.O = socket_config.chname.O.filter(Boolean);
    socket_config.chname.C = socket_config.chname.C.filter(Boolean);
    extendWrite(primus, socket_config);
};
/**
 * Update websocket subscription config
 * @param {object} primus
 * @param {object} state - Websocket reducer state
 * @param {string} wskey
 */ var updateConfig = function(primus, state, wskey) {
    var ch = {};
    if (!ch.S) ch.S = state.stream;
    if (!ch.C) ch.C = state.company || [];
    if (!ch.O) ch.O = state.orderbook || [];
    if (!ch.H2) ch.H2 = state.hotlist;
    var socket_config = getConfig(ch.C, ch.S, ch.O, ch.H2);
    if (wskey) socket_config.wskey = wskey;
    socket_config.chname.O = socket_config.chname.O.filter(Boolean);
    socket_config.chname.C = socket_config.chname.C.filter(Boolean);
    extendWrite(primus, socket_config);
};
function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(var i = arr1.length; i--;){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
/**
 * To re evaluate config
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */ var updateGeneralWsConfig = function(state, newConfig) {
    var config = composeGeneralWsConfig(newConfig); // generate new config
    var result = needRerender(state, config); // need rerender ?
    if (!result) return false; // difference not found
    return config;
};
var needRerender = function(state, next) {
    var livedata_channels = (state || {}).livedata_channels;
    if (!livedata_channels) livedata_channels = {};
    var toCompare = {
        stream: livedata_channels.stream || [],
        company: livedata_channels.company || [],
        orderbook: livedata_channels.orderbook || [],
        hotlist: livedata_channels.hotlist || false
    };
    var orderbook_diff = !arraysEqual(toCompare.orderbook, next.orderbook); // company difference
    var company_diff = !arraysEqual(toCompare.company, next.company); // company difference
    var stream_diff = !arraysEqual(toCompare.stream, next.stream); // stream difference
    var hotlist_diff = toCompare.hotlist !== next.hotlist;
    if (stream_diff || company_diff || orderbook_diff || hotlist_diff) return true;
    return false; // no need to re render
};
var composeGeneralWsConfig = function(state) {
    var config = {};
    /**
   * config for company
   */ config.company = [];
    var merged = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.company) || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.orderbook) || []));
    var merged_orderbook = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.orderbook) || []);
    var unique = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(merged)); // uniq array
    var unique_orderbook = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(merged_orderbook)); // uniq array orderbook
    var new_map = unique.filter(function(v) {
        return v !== undefined;
    }).map(function(v) {
        return typeof v === "string" ? v.toUpperCase() : v;
    });
    var new_orderbook = unique_orderbook.filter(function(v) {
        return v !== undefined;
    }).map(function(v) {
        return typeof v === "string" ? v.toUpperCase() : v;
    });
    // console.log('::-- new_map ', new_map) // unique
    // console.log('::-- new_orderbook', new_orderbook) // unique
    config.company = new_map;
    config.orderbook = new_orderbook;
    // console.log('::@@ Socket O SUBSCRIBE', new_orderbook)
    // console.log('::@@ Socket C SUBSCRIBE', new_map)
    /**
   * end config for company
   */ /**
   * config for stream
   */ var stream = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.stream) || []);
    config.stream = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(stream));
    /**
   * end config for stream
   */ // Socket config for Hotlist, only available if widget has data
    config.hotlist = state === null || state === void 0 ? void 0 : state.hotlist;
    return config;
};
var convertWSKeyArray = function(wskey) {
    if (wskey && typeof wskey === "string") {
        return [
            wskey
        ];
    }
    return wskey;
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    parseSocketString: parseSocketString,
    setLocalWskey: setLocalWskey,
    getLocalWskey: getLocalWskey,
    useLocalWskey: useLocalWskey,
    getConfig: getConfig,
    extendWrite: extendWrite,
    initConfig: initConfig,
    updateConfig: updateConfig,
    updateGeneralWsConfig: updateGeneralWsConfig,
    convertWSKeyArray: convertWSKeyArray
});


/***/ })

}]);